<template>
  <div class="container">
    <div class="row">
      <div v-if="locale == 'dk'">
        <h1 class="page-title">Vilkår og betingelser</h1>
        <h2 class="page-title">Oral-B penge-tilbage-garanti</h2>
        <br />
        <div class="text-center mb-5 w-100">
          <div style="font-style: italic">
            Prøv vores produkt og få dine penge tilbage
          </div>
          <br />
          <hr />
          <br />
          <div style="font-style: italic">
            Kan du ikke lide det produkt, du har købt? – Intet problem, tilmeld
            dig, returner produktet og få dine penge tilbage!
          </div>
        </div>
        <br />
        <b>Kampagnen på et blik:</b>
        <div class="box-notice">
          <ul>
            <li>
              Køb Oral-B-produkter, der deltager i den deltagende periode
              (mellem <b>01.07.2025</b> og <b>31.08.2026</b>) hos en forhandler.
            </li>
            <li>
              Registrer dig på salgsfremmende webstedet, upload købsbeviset for
              salgsfremmende produktet og indsend registreringsformularen. Efter
              kontrol vil du modtage en e-mail med oplysninger om returnering af
              produktet. Når Oral-B produktet er modtaget sammen med alle
              nødvendige dokumenter, får du pengene tilbage for det returnerede
              produkt via bankoverførsel. Behold venligst det originale
              købsbevis!
            </li>
            <li>
              Deltagelse i kampagnen er kun mulig i dit eget navn og pr. person
              med <b>5 købsbeviser</b> og <b>5 salgsfremmende produkter</b>.
            </li>
            <li>
              Hvert købsbevis kan kun bruges én gang. Hvis du ønsker at
              returnere mere end ét produkt fra ét købsbevis, skal du returnere
              alle produkterne på én gang.
            </li>
            <li>
              <b>Vigtigt</b> Du skal registrere din kvittering og dit produkt
              via vores websted www.oral-b-moneyback.com inden for
              <b>60 dage efter købet</b>. Så snart din online-deltagelse er
              bekræftet, har du <b>10 dage</b> til at udskrive returformularen
              og sende den sammen med dit produkt til et af de
              P&G-servicecentre, der er anført i disse vilkår og betingelser.
            </li>
            <li>
              Fristen for indsendelse af den online registreringsformular og
              upload af købsbeviset er <b>30.10.2026</b>. Vores supportafdeling
              er tilgængelig indtil <b>19.12.2026</b>.
            </li>
          </ul>
        </div>
        <br />
        <div>
          Tak for din interesse i vores Oral-B penge-tilbage-garanti. Selv om vi
          har forsøgt at give dig alt det vigtigste på et øjeblik: Det er lidt
          mere kompliceret. Du finder derfor også det "småt skrevet" i disse
          vilkår og betingelser.
        </div>
        <ul class="list" ref="list">
          <li class="list-item-wrapper">
            <div class="number">Hvem er involveret i kampagnen?</div>
            <div class="list-item-details">
              <p class="western">
                <span lang="sv-SE"
                  >Kampagnen er organiseret for deltagere bosiddende i Norge,
                  Danmark, Sverige og Finland af Procter &amp; Gamble
                  International Operations SA, Route de Saint-Georges 47, 1213
                  PETIT-LANCY, Geneve.
                </span>
              </p>
              <p class="western" lang="sv-SE"></p>
              <p class="western" lang="sv-SE"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en">Hvad handler kampagnen om?</span>
            </div>
            <p class="western">
              <span lang="sv-SE"
                >Kampagnen giver dig mulighed for at afprøve og returnere visse
                Oral-B-produkter inden for </span
              ><span lang="sv-SE"><strong>60 dage</strong></span
              ><span lang="sv-SE">. </span
              ><span lang="en">Følgende produkter ("</span
              ><span lang="en"><strong>Salgsfremmende produkter</strong></span
              ><span lang="en">") deltager i denne kampagne:</span>
            </p>
            <p class="western"></p>
            <dl>
              <dd>
                <div style="overflow-x: auto">
                  <table width="607" cellspacing="0" cellpadding="0">
                    <colgroup>
                      <col width="217" />
                      <col width="87" />
                    </colgroup>
                    <colgroup>
                      <col width="198" />
                      <col width="104" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td width="217" height="21">
                          <p>
                            <span lang="en">Oral-B Laboratory Clean 1</span>
                          </p>
                        </td>
                        <td width="87">
                          <p><span lang="en">4210201238331</span></p>
                        </td>
                        <td width="198">
                          <p><span lang="en">Oral-B iO8 S Black UCB</span></p>
                        </td>
                        <td width="104">
                          <p><span lang="en">4210201307327</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="217" height="20">
                          <p>
                            <span lang="en">Oral-B Laboratory Clean 3</span>
                          </p>
                        </td>
                        <td width="87">
                          <p><span lang="en">4210201291947</span></p>
                        </td>
                        <td width="198">
                          <p><span lang="en">Oral-B iO8 S Violet UC</span></p>
                        </td>
                        <td width="104">
                          <p><span lang="en">4210201307389</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="217" height="20">
                          <p>
                            <span lang="en">Oral-B Laboratory Clean 5</span>
                          </p>
                        </td>
                        <td width="87">
                          <p><span lang="en">4210201238492</span></p>
                        </td>
                        <td width="198">
                          <p><span lang="en">Oral-B iO9 S White UC</span></p>
                        </td>
                        <td width="104">
                          <p><span lang="en">4210201307556</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="217" height="19">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Frozen Hbox + TC</span
                            >
                          </p>
                        </td>
                        <td width="87">
                          <p><span lang="en">4210201309512</span></p>
                        </td>
                        <td width="198">
                          <p><span lang="en">Oral-B iO9 S Black UCB</span></p>
                        </td>
                        <td width="104">
                          <p><span lang="en">4210201307594</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </dd>
            </dl>
            <p class="western"></p>
            <dl>
              <dd>
                <div style="overflow-x: auto">
                  <table width="607" cellspacing="0" cellpadding="0">
                    <colgroup>
                      <col width="220" />
                      <col width="84" />
                    </colgroup>
                    <colgroup>
                      <col width="222" />
                      <col width="81" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality Kids Spiderman CLS</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201320074</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B iO9 S Rose Quartz UC</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307631</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Mandalorian CLS</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201386230</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO8 Duo White UC / Black UC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201315766</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Starwars Hbox + TC</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201309444</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO6 White UC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201377665</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Star wars CLS</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201241201</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO6 Grey Opal UC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201377788</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Frozen CLS</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201241317</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO6 Pink Sand GC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201378143</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Starwars Hbox</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201241331</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO6 Duo White UC / Pink UC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201378198</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Oral-B Kids D12 Starter Pack Star Wars</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201307105</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2 2400N Black SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201258117</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Kids D12 Starter Pack Frozen</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201307242</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2 2400N Pink SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201258544</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Starter Pack Turquiose CA</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201260899</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2 2300W White SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201258643</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Frozen Hbox</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201241379</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2 2200S Blue SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201274681</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p><span lang="en">Oral-B Pro 680 White CA</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201235811</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B Pro 2900 Black CA</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201271598</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Pro 3 Junior Star Wars Sens</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201396109</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B Pro 2700 Blue CA</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201179078</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Pro 3 Junior Minnie Sens</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201396123</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2000 White SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201249924</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en">Oral-B Pro3 3400N Black CA</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291053</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Pro2 2500 Black CA Black</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201319412</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro3 3400N Pink Sensi</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291077</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro2 2500 Pink 3DW</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201319313</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro3 3200S Blue Sensi</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291091</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B Pro 2000 Blue CA</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201178682</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro3 3000 PureClean</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201365280</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Oral B Clean &amp; Protect Pro 2 Black
                              CA</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201396000</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en">Oral-B Pro3 3300W White Sensi</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291114</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Pro 2 2000 Black CA Black</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201267782</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p><span lang="en">Oral-B Pro 890 White SUT</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201235941</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Pro 2 2000 Pink CA</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201178736</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Pro3 3900N White Sens +Black Sens</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291503</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO 6N Black UCB</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201409113</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Pro3 3950N Black CA + Pink CA</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291374</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO7 N White UC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307181</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Smart 4 4900 White SUT</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201271611</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO8 SE Black UC + Pouch</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307433</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20400N Black CA Black</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201272922</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO8 SE Violet UC + Pouch</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307464</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20300W White SUT</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201276869</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO9 N Black UCB</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307570</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20200S RoseGold SUT</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201274858</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B iO9 N RoseQuartz UC</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307617</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 100 White CA CLS</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201199441</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B iO9 N White UC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201307532</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 100 White CA HB</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201199472</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO6 Duo Black UC / Pink UC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201411536</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 170 Blue CA HB</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201201038</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B iO9 Duo Black UC / Rose Quartz UC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201411550</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p><span lang="en">Oral-B Junior Green SUT</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201202318</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B PROFESSIONAL GUM CARE 1</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201238355</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p><span lang="en">Oral-B Junior Purple SUT</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201202332</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B PROFESSIONAL GUM CARE 2</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201238454</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 760 Black CA</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201137191</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B PROFESSIONAL GUM CARE 3</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201238515</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 700 Turquoise CA</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201124092</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B PROFESSIONAL GENIUS 10 GUM CARE</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201271864</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 700 White SUT</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201157786</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality100 Kids Pixar Hbox + TC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201314592</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Pro 1 750 Black CA Black</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201319399</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 150 White CA HB</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201200772</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 750 Pink 3DW</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201312499</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Junior D501 Star Wars SUT</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201245780</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p><span lang="en">Oral-B Pro1 750 White CA</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201312291</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Junior D501 Minnie SUT</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201245896</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en">Oral-B Pro 1 800 White SUT</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201077596</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Smart 4 4400N White SUT</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201255277</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 900 White SUT</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201187370</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Smart 4 4200S White CA</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201274728</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p><span lang="en">Oral-B Pro3 3700 CA</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201291176</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Smart 5000N White CA</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201203315</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Pro 3 3000 CA Black Edition</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201289364</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Smart 5 5400N White SUT</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201255499</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro3 3000 White Sensi</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201289470</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Smart 5 5200S White CA</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201274773</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Pro3 3500 Black CA Black</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201289517</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B GENIUS 8 8100S WHITE SU</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201261414</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="21">
                          <p>
                            <span lang="en">Oral-B Pro3 3500 WT Sensi</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201289562</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20100S Blush Pink SUT</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201279785</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="20">
                          <p>
                            <span lang="en">Oral-B Pro 1 970 White CA</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201207955</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Oral-B Smart 4 4000N White CA</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201203377</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Oral-B Smart Sensitive White Sensi</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201396697</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Oral-B Smart 4 4500 3DW</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201312536</span></p>
                        </td>
                      </tr>
                      <!-- NEW ADDED JSDEV-17782 -->
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">Pro Clean White + TC</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540757802</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Pro1 Duo Black / Turquoise</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8001090915016</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">Pro1 Pink + TC</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8001090914217</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Pro1 Black + TC</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8001090914170</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">Pro1 Turquoise + TC</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8001090914132</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Pro1 Black + Extra Brush Head</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540771457</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Pro1 Turquoise + Extra Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540771914</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Pro1 Pink + Extra Brush Head</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540771501</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Oral B Clean & Protect Pro 2 Black CA
                            </span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201396024</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Pro3 Black + Extra CA Black Brush Head + TC
                            </span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540759912</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Pro3 White + Extra Sensi Brush Head + TC</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540759929</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Pro3 Black + Extra CA Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540759868</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Pro3 Black + Extra CA Black Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540759790</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Pro3 Pink + Extra CA Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540802083</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Pro3 Blue + Extra Sensi Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540759813</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Pro3 White + Extra CA Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540760857</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Pro3 White + Extra Sensi Brush Head</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540760918</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Pro3 Duo Black / White</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540760765</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">Pro3 Duo Black / Pink</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540760277</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">iO3S Matt Black</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540730898</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">iO3S Ice Blue</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540730935</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">iO3S Blush Pink</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540730843</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en">iO3 Duo Matt Black / Ice Blue</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540731659</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">iO10 Stardust White</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201435624</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">iO10 Cosmic Black</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201435648</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Laboratory Clean 1</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540772119</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en">Laboratory Clean 3 +1 refill</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540760345</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">iO Laboratory Clean 5</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201445098</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Vitality Pro Kids Frozen HBOX + TC</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540773178</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Vitality Pro Kids Frozen HBOX + Extra
                              Refill</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540772645</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en">Vitality Pro Kids Frozen HBOX</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540772409</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Vitality Pro Kids Spiderman HBOX + TC</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540773390</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Vitality Pro Kids Spiderman HBOX + Extra
                              Refill</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540773659</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Vitality Pro Kids Spiderman HBOX</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540772768</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p><span lang="en">Pro1 Junior 6+ Green</span></p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540743027</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Pro1 Junior 6+ Purple </span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540742891</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en">Pro 3 Junior 6+ Star Wars</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">8006540957196</span></p>
                        </td>
                        <td width="222">
                          <p><span lang="en">Pro 3 Junior 6+ Frozen</span></p>
                        </td>
                        <td width="81">
                          <p><span lang="en">8006540774724</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en">Vitality Pro Lilac CA HBOX</span>
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201426967</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en">Vitality Pro Black CA HBOX</span>
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201427063</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Vitality Pro Vapor Blue CA HBOX</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201446392</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Vitality Pro Black CA HBOX + Extra Refill</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201432326</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="220" height="19">
                          <p>
                            <span lang="en"
                              >Vitality Pro Lilac CA HBOX + Extra Refill</span
                            >
                          </p>
                        </td>
                        <td width="84">
                          <p><span lang="en">4210201432340</span></p>
                        </td>
                        <td width="222">
                          <p>
                            <span lang="en"
                              >Vitality Pro Vapor Blue CA CLS</span
                            >
                          </p>
                        </td>
                        <td width="81">
                          <p><span lang="en">4210201446491</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </dd>
            </dl>
            <p class="western"></p>
            <dl>
              <dd>
                <div style="overflow-x: auto">
                  <table width="606" cellspacing="0" cellpadding="0">
                    <colgroup>
                      <col width="227" />
                      <col width="76" />
                    </colgroup>
                    <colgroup>
                      <col width="223" />
                      <col width="80" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td width="227" height="19">
                          <p>
                            <span lang="en"
                              >Oral-B Smart Sensitive WT Sensi + TC</span
                            >
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201396673</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en">Oral-B Genius 8600 Silver SUT</span>
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201261506</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Smart 5 5900 Black + White CA</span
                            >
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201180074</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en">Oral-B Genius 8500 Silver CA</span>
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201314530</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="223">
                          <p>
                            <span lang="sv-SE"
                              >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201157601</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201157601</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20100S Black CA BK</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201247357</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20100S Black CA BK</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201247357</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="21">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20900 RoseG SUT/Black CA
                              Black</span
                            >
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201276982</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X 20100S White SUT</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201247166</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 100 Pink CA HB</span
                            >
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201200710</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X Blush Pink SUT Art of
                              Brushing</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201295358</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="20">
                          <p>
                            <span lang="en"
                              >Oral-B Vitality 100 Black CA HB</span
                            >
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201200758</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en"
                              >Oral-B Genius X Black CA Black Art of
                              Brushing</span
                            >
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201295402</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="21">
                          <p><span lang="en">Oral-B iO7 S White UC</span></p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201306702</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en">Oral-B Smart 6 6600 Blue CA</span>
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201203292</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td width="227" height="20">
                          <p>
                            <span lang="en">Oral-B iO7S Black Onyx UCB</span>
                          </p>
                        </td>
                        <td width="76">
                          <p><span lang="en">4210201364733</span></p>
                        </td>
                        <td width="223">
                          <p>
                            <span lang="en">Oral-B Genius 8200W White CA</span>
                          </p>
                        </td>
                        <td width="80">
                          <p><span lang="en">4210201203179</span></p>
                        </td>
                      </tr>
                      <template v-for="(item, idx) in newProducts">
                        <tr v-if="idx % 2 === 0" :key="idx">
                          <td width="227" height="20">
                            <p>
                              <span lang="en">{{ item.name }}</span>
                            </p>
                          </td>
                          <td width="76">
                            <p>
                              <span lang="en">{{ item.ean }}</span>
                            </p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en">{{
                                newProducts[idx + 1]
                                  ? newProducts[idx + 1].name
                                  : ""
                              }}</span>
                            </p>
                          </td>
                          <td width="80">
                            <p>
                              <span lang="en">{{
                                newProducts[idx + 1]
                                  ? newProducts[idx + 1].ean
                                  : ""
                              }}</span>
                            </p>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </dd>
            </dl>
            <p class="western"></p>
            <p class="western">
              <span lang="sv-SE"
                ><span lang="sv-SE"><strong>BEMÆRK</strong></span
                >: Du skal registrere din kvittering og dit produkt via vores
                websted
                <a href="https://www.oral-b-moneyback.com/dk"
                  >www.oral-b-moneyback.com</a
                >inden for <span lang="sv-SE"><strong>60 dage </strong></span>.
                Efter bekræftelse af online-registreringen har du </span
              ><span lang="sv-SE"><strong>10 dage </strong></span
              ><span lang="sv-SE"
                >til at sende dit produkt sammen med den returformular, der er
                vedhæftet din bekræftelsesmail, til et af P&amp;G Service
                Centrene, der er anført nedenfor.</span
              >
            </p>
            <p class="western">
              <span lang="sv-SE"
                >Tilbagebetalingen svarer til den faktisk betalte
                købspris.</span
              >
            </p>
            <p class="western"><span lang="sv-SE">Kampagnen vedrører</span></p>
            <ul>
              <li>
                <p>
                  <span lang="sv-SE"
                    >til køb af salgsfremmende produkter mellem </span
                  ><span lang="sv-SE"><strong>01.07.2025 </strong></span
                  ><span lang="sv-SE">og </span
                  ><span lang="sv-SE"><strong>31.08.2026 </strong></span
                  ><span lang="sv-SE">("</span
                  ><span lang="sv-SE"><strong>Kampagneperioden</strong></span
                  ><span lang="sv-SE">"), </span
                  ><span lang="en">datoen for købsbeviset er relevant;</span>
                </p>
              </li>
            </ul>
            <p class="western"></p>
            <ul>
              <li>
                <p>
                  <span lang="sv-SE"
                    >til køb - herunder onlinekøb - hos en detailhandler
                    ("</span
                  ><span lang="sv-SE"><strong>Kampagneperioden</strong></span
                  ><span lang="sv-SE">");</span>
                </p>
              </li>
            </ul>
            <p class="western" lang="sv-SE"></p>
            <ul>
              <li>
                <p>
                  <span lang="sv-SE"
                    >udtrykkeligt ikke på "private køb" af salgsfremmende
                    produkter, herunder online / auktionsplatforme.</span
                  >
                </p>
              </li>
            </ul>
            <p class="western" lang="sv-SE"></p>
            <div class="list-item-details"></div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="sv-SE">Hvem kan deltage i kampagnen?</span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="sv-SE">Du kan deltage i kampagnen, hvis du</span>
              </p>
              <p class="western" lang="sv-SE"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >er slutbruger, er over 18 år og bosiddende i Norge,
                        Danmark, Sverige eller Finland,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >have en bankkonto med et IBAN, der er tildelt et
                        europæisk land,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p><span lang="en">have en e-mail-adresse og</span></p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >kan få adgang til kampagnens websted på
                        <a href="https://www.oral-b-moneyback.com/dk"
                          >www.oral-b-moneyback.com</a
                        >.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="sv-SE"
                  >Hvert IBAN og hver e-mail-adresse kombineres til en
                  brugerkonto og kan kun deltage i kampagnen i samme
                  kombination.</span
                >
              </p>
              <p class="western" lang="sv-SE"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="sv-SE">Hvordan kan du deltage i kampagnen?</span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="sv-SE">For at deltage i kampagnen skal du</span>
              </p>
              <p class="western" lang="sv-SE"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >have købt et deltagende produkt i detailhandlen i
                        kampagneperioden samt være i besiddelse af det købte
                        deltagende produkt og købsbeviset,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >åbne online-formularen
                        <a href="https://www.oral-b-moneyback.com/dk"
                          >www.oral-b-moneyback.com</a
                        >,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >oplyse stregkodenummeret på salgsfremmende produktet
                        eller uploade et foto af stregkoden på dit
                        salgsfremmende produkt,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >uploade et foto af dit købsbevis,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >uploade et foto af produktsiden med stregkoden,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >oplyse dine kontooplysninger (IBAN, BIC, for- og
                        efternavn på kontohaveren),</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >registrere dig ved at oplyse din e-mail-adresse og
                        andre personlige oplysninger og</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >gennemføre de trin til verifikation og forebyggelse af
                        misbrug/svindel, der er vist på kampagnens websted (se
                        nedenfor). Ved at klikke på knappen for at fuldføre din
                        deltagelse accepterer du også disse vilkår og
                        betingelser.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western" lang="sv-SE"></p>
              <p class="western">
                <span lang="sv-SE"
                  >Den vellykkede afslutning af online-deltagelsesprocessen og
                  referencenummeret for din deltagelse vil blive vist på
                  kampagnens websted.</span
                >
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >Derefter skal du sende produktet sammen med den tilsvarende
                  kupon til servicecentret inden for </span
                ><span lang="sv-SE"><strong>10 dage</strong></span
                ><span lang="sv-SE"
                  >. Du vil modtage din refusion inden for 6 uger efter, at
                  pakken er ankommet og bekræftet i servicecentret.</span
                >
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >Online-deltagelsesprocessen skal være afsluttet inden for
                  <span lang="sv-SE"><strong>60 dage efter købet</strong></span
                  >. Fristen for indsendelse af den online registreringsformular
                  og upload af købsbeviset er </span
                ><span lang="sv-SE"><strong>30.10.2026</strong></span
                ><span lang="sv-SE"> ("</span
                ><span lang="sv-SE"><strong>Afslutningsdato</strong></span
                ><span lang="sv-SE">").</span>
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >Kun registrerede pakker med gyldigt trackingnummer kan
                  accepteres. Portoudgifterne refunderes ikke.</span
                >
              </p>
              <p class="western">
                <span lang="sv-SE"
                  ><strong> P&amp;G Servicecentrets </strong></span
                ><span lang="sv-SE">adresser i dit land er:</span>
              </p>
              <p class="western" lang="sv-SE"></p>
              <h1 class="western"><span lang="sv-SE">Norge</span></h1>
              <p class="western"><span lang="sv-SE">L.G. Elektro A/S</span></p>
              <p class="western"><span lang="sv-SE">Kolstien 4</span></p>
              <p class="western"><span lang="sv-SE">5097 Bergen</span></p>
              <p class="western"><span lang="sv-SE">Norge</span></p>
              <p class="western" lang="sv-SE"></p>
              <h1 class="western"><span lang="sv-SE">Sverige</span></h1>
              <p class="western">
                <span lang="sv-SE">El &amp; Digital Service AB</span>
              </p>
              <p class="western"><span lang="sv-SE">Folkungagatan 144</span></p>
              <p class="western"><span lang="sv-SE">116 30 Stockholm</span></p>
              <p class="western"><span lang="sv-SE">Sverige</span></p>
              <p class="western" lang="sv-SE"></p>
              <h1 class="western"><span lang="sv-SE">Finland</span></h1>
              <p class="western"><span lang="sv-SE">AIDE Europe Oy</span></p>
              <p class="western"><span lang="sv-SE">Haukilahdenkatu 4</span></p>
              <p class="western"><span lang="sv-SE">FI-00550 Helsinki</span></p>
              <p class="western"><span lang="sv-SE">Suomi</span></p>
              <h1 class="western"><span lang="sv-SE">Danmark</span></h1>
              <p class="western">
                <span lang="sv-SE">CJ Hvidevareservice</span>
              </p>
              <p class="western"><span lang="sv-SE">Thorndahlsvej 11</span></p>
              <p class="western"><span lang="sv-SE">9200 Aalborg SV</span></p>
              <p class="western"><span lang="sv-SE">Danmark</span></p>
              <p class="western">
                <span lang="sv-SE"
                  >Vær opmærksom på følgende med hensyn til stregkoden på det
                  kampagneprodukt, der kræves for at deltage, og dit
                  købsbevis:</span
                >
              </p>
              <p class="western" lang="sv-SE"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Sørg for, at stregkoden (dvs. den sædvanlige stregkode
                        bestående af sorte streger med hvide mellemrum) er
                        tydeligt synlige på de tilsvarende produktfotos.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Som købsbevis i henhold til disse vilkår og betingelser
                        er kun kvitteringen eller fakturaen fra den forhandler,
                        der har gennemført kampagnen, gyldig. Ordrebekræftelser,
                        følgesedler eller lignende dokumenter er ikke
                        tilstrækkelige.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >På fotoet af købsbeviset skal det tydeligt fremgå, hvem
                        forhandleren er, kvitteringens ID (ikke bankens
                        transaktions-ID), dato og klokkeslæt for kvitteringen,
                        salgsfremmende produktet, salgsfremmende produktets pris
                        og det samlede beløb på kvitteringen, den angivne moms
                        og eventuelle rabatter.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Fotoet af købsbeviset må ikke være overbelyst, sløret
                        eller for mørkt. Scannede kvitteringer er ikke
                        tilstrækkelige for deltagelse, der kræves detaljerede
                        fotos.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Kun købsbeviset må vises på fotoet af købsbeviset; det
                        købte salgsfremmende produkt må ikke fotograferes sammen
                        med købsbeviset.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="sv-SE"
                  >Når deltagelsesprocessen er afsluttet med succes - dvs. når
                  alle de oplysninger, du har givet eller uploadet, er modtaget
                  - samt referencenummeret for din deltagelse vil blive vist på
                  kampagnens websted; du vil også modtage en e-mail til den
                  e-mailadresse, du har oplyst.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en">Hvad er der ellers at overveje?</span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="sv-SE"><u>Testkampagne:</u></span
                ><span lang="sv-SE">
                  Denne kampagne giver dig mulighed for at teste Oral-B
                  salgsfremmende produkterne. På denne baggrund (og på baggrund
                  af erfaringer med lignende aktioner) er vi nødt til at
                  definere nogle spilleregler med hensyn til kampagnens
                  mål:</span
                >
              </p>
              <p class="western" lang="sv-SE"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Deltagelse i kampagnen er kun mulig i dit eget navn og
                        pr. person med 5 købsbeviser og 5 salgsfremmende
                        produkter.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Hvert købsbevis kan kun bruges én gang til at deltage i
                        kampagnen; dette gælder også, hvis der er vist mere end
                        5 deltagende produkter på et købsbevis.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Hvis du indløser en rabatkupon til salgsfremmende
                        produktet på samme tid, vil du kun modtage en refusion
                        fra Justsnap for det faktisk betalte beløb.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Et produkt, der allerede har deltaget i en anden
                        kampagne, kan kun refunderes for denne kampagne op til
                        den faktiske produktpris. Hvis du således modtager
                        10EUR/100KR eller 20EUR/200KR i vores Oral-B
                        tilbagebetaling-kampagne, vil det tilsvarende beløb
                        blive fratrukket fra din refusion i Penge tilbage
                        kampagnen. Et produkt, der refunderes i denne kampagne,
                        kan ikke bruges i nogen anden Procter &amp;
                        Gamble-kampagne.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Desuden hvert IBAN og hver e-mail-adresse er kombineret
                        til en brugerkonto og kan kun deltage i hele kampagnen i
                        én enkelt kombination.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Der påtages intet ansvar for forkert angivelse af
                        IBAN-nummeret. Der er en engangs mulighed for at ændre
                        et ugyldigt IBAN-nummer, hvorefter deltagelsen bliver
                        ugyldig. Hvis du vil ændre dine bankoplysninger, kan du
                        kontakte vores supporttjeneste, som udelukkende er
                        oprettet til IBAN-ændringer (via e-mail<a
                          style="color: #6eac1c"
                          href="mailto:support@oral-b-moneyback.com"
                          >:</a
                        ></span
                      ><a
                        style="color: #6eac1c"
                        href="mailto:support@oral-b-moneyback.com"
                        ><span lang="sv-SE"
                          ><u>support@oral-b-moneyback.com</u></span
                        ></a
                      ><span lang="sv-SE">) indtil </span
                      ><span lang="sv-SE"><strong>19.12.2026</strong></span
                      ><span lang="sv-SE"
                        >. (Hvis du har spørgsmål, der ikke vedrører
                        IBAN-ændringen, bedes du kontakte os ved hjælp af de
                        kontaktmuligheder, der er angivet i afsnit I).</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Ufuldstændige, ukorrekte eller for sent indsendte
                        ansøgninger accepteres ikke. Afsenderbevis vil ikke
                        blive godkendt som bevis for modtagelse. Vi er ikke
                        ansvarlige for formularer og/eller deres indhold, der er
                        forsvundet eller beskadiget eller forsinket.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >I tilfælde af forkert indsendt pakkeindhold har
                        forbrugeren en engangs mulighed for at sende de
                        nødvendige dokumenter på ny. Hvis der ved det andet
                        forsøg mangler noget indhold eller er forkert igen,
                        bliver deltagelsen ugyldig.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="sv-SE"><u>Forebyggelse af misbrug og svig:</u></span
                ><span lang="sv-SE">
                  Vores hidtidige erfaringer viser desværre, at sådanne
                  kampagner desværre jævnligt fører til forsøg på misbrug og
                  svig, nogle gange i betydeligt omfang. Derfor skal vi også i
                  denne kampagne træffe forskellige foranstaltninger for at
                  forhindre og opdage sådanne forsøg. Vi har forståelse for, at
                  dette kan medføre ekstra arbejde for Dem. Vi har dog forsøgt
                  at gøre vores nødvendige foranstaltninger så ukomplicerede som
                  muligt for dig som deltager:</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Ved hjælp af den kontrol, der er beskrevet ovenfor i
                        afsnit D som en del af deltagelsesprocessen,
                        kontrollerer vi, om de oplysninger, som en deltager har
                        givet (IBAN og e-mail-adresse), allerede er blevet
                        anvendt til deltagelse i kampagnen; i dette tilfælde
                        opretter hvert IBAN i kombination med en e-mail-adresse
                        en brugerkonto, og denne kombination må ikke være
                        forskellig ved flere deltagelser.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Under den videre behandling vil deltageroplysningerne
                        også blive kontrolleret, navnlig de stregkoder og
                        købsbeviser, som deltagerne har uploadet.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="sv-SE"><u>Opbevaring af købsbeviset:</u></span
                ><span lang="sv-SE"> Bemærk venligst, at du skal </span
                ><span lang="sv-SE"
                  ><u
                    >opbevare det originale købsbevis, der blev brugt til
                    deltagelse, indtil du har modtaget
                    tilbagebetalingsbeløbet.</u
                  ></span
                ><span lang="sv-SE">
                  I enkelte tilfælde skal du sende det med posten til kontrol,
                  før der kan udstedes en tilbagebetaling. I dette tilfælde skal
                  du sende det originale købsbevis i en kuvert med tilstrækkelig
                  porto til den angivne adresse. Ufrankerede varer accepteres
                  ikke, og det originale købsbevis kan ikke returneres, efter at
                  det er blevet kontrolleret (lav om nødvendigt en kopi til dit
                  eget brug); intet ansvar for tab med posten.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="sv-SE">Hvad sker der efter din deltagelse?</span>
            </div>
            <div class="list-item-details">
              <p class="western"><span lang="en">I denne forbindelse</span></p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Der vil blive foretaget en kontrol for at forhindre
                        misbrug og svindel. I den forbindelse kan det originale
                        købsbevis i enkelte tilfælde blive krævet af dig;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Der vil blive sendt en e-mail for at bekræfte dit
                        pengekrav til den e-mailadresse, du har oplyst; dette
                        sker normalt inden for to arbejdsdage efter modtagelsen
                        af oplysningerne;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >P&amp;G Service Center bekræfter pakken med det
                        deltagende produkt;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="sv-SE"
                        >Tilbagebetalingsbeløbet vil blive udbetalt til den
                        konto, som du har angivet via IBAN; dette sker normalt
                        inden for seks uger efter eksamen er afsluttet.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="sv-SE"
                  >Vi forbeholder os retten til at udelukke enhver deltager fra
                  kampagnen, hvis der er mistanke om, at der er afgivet falske
                  oplysninger ved deltagelsen, at der er forsøgt at manipulere
                  kampagnen, eller at disse vilkår og betingelser er blevet
                  overtrådt på anden vis. I dette tilfælde vil der ikke blive
                  sendt nogen bekræftelsesmail til dig. Du kan bevise over for
                  os, at der ikke var nogen overtrædelse af vilkår og
                  betingelser i dit tilfælde.</span
                >
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >Vi forbeholder os også retten til at ændre eller tilpasse
                  disse vilkår og betingelser og til at afbryde, forlænge eller
                  afslutte kampagnen til enhver tid uden forudgående
                  varsel.</span
                >
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >For deltagere fra Norge gælder norsk lov, for deltagere fra
                  Sverige gælder svensk lov, for deltagere fra Finland gælder
                  finsk lov og for deltagere fra Danmark gælder dansk lov.
                  Dommernes afgørelse er endelig.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="sv-SE"
                >Hvem kan jeg kontakte, hvis jeg har spørgsmål om
                kampagnen?</span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="sv-SE"
                  >Hvis du har spørgsmål om kampagnen, er den hurtigste og
                  eneste måde at kontakte os på via
                  <a href="mailto:contact@oral-b-moneyback.com"
                    >contact@oral-b-moneyback.com</a
                  >. Denne mulighed eksisterer indtil </span
                ><span lang="sv-SE"><strong>19.12.2026.</strong></span>
              </p>
              <p class="western">
                <span lang="sv-SE"
                  >Du kan også kontakte Procter &amp; Gamble International
                  Operations SA pr. e-mail
                  <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com </a
                  >og pr. post (Route de Saint-Georges 47 1213 PETIT-LANCY,
                  Geneve).</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale == 'fi'">
        <h1 class="page-title">Ehdot ja edellytykset</h1>
        <h2 class="page-title">Oral-B Moneyback -takuu</h2>
        <br />
        <div class="text-center mb-5 w-100">
          <div style="font-style: italic">
            Kokeile tuotettamme ja saat rahasi takaisin
          </div>
          <br />
          <hr />
          <br />
          <div style="font-style: italic">
            Etkö pidä ostamastasi tuotteesta? – Ei hätää, rekisteröidy, palauta
            tuote ja saat rahasi takaisin!
          </div>
        </div>
        <br />
        <b>Kampanja yhdellä silmäyksellä:</b>
        <div class="box-notice">
          <ul>
            <li>
              Osta Oral-B:n osallistuvia tuotteita osallistumisjakson aikana (<b
                >01.07.2025</b
              >
              - <b>31.08.2026</b>) jälleenmyyjältä.
            </li>
            <li>
              Rekisteröidy myynninedistämissivustolla, lataa ostotodistus
              myynninedistämistuotteesta ja lähetä rekisteröintilomake.
              Tarkistuksen jälkeen saat sähköpostiviestin, jossa on tuotteen
              palautuksen yksityiskohdat. Kun tuote on vastaanotettu yhdessä
              kaikkien tarvittavien asiakirjojen kanssa, saat palautetun
              tuotteen hinnan takaisin pankkisiirrolla. Säilytä alkuperäinen
              ostotodistus!
            </li>
            <li>
              Kampanjaan osallistuminen on mahdollista vain omalla nimelläsi ja
              henkilöä kohden enintään <b>5</b> ostokuittia ja yhteensä
              <b>5</b> osallistuvaa tuotetta vastaan.
            </li>
            <li>
              Kutakin ostotodistusta voi käyttää vain kerran. Jos haluat
              palauttaa useamman kuin yhden tuotteen yhdestä ostotodistuksesta,
              sinun on palautettava kaikki tuotteet kerralla.
            </li>
            <li>
              <b>Tärkeää</b>: Sinun on rekisteröitävä kuittisi ja tuotteesi
              verkkosivustollamme www.oral-b-moneyback.com
              <b>60 päivän</b> kuluessa ostosta. Heti kun osallistumisesi
              verkossa on vahvistettu, sinulla on <b>10 päivää</b> aikaa
              tulostaa palautuslomake ja lähettää se yhdessä tuotteen kanssa
              johonkin näissä ehdot ja edellytykset luetelluista P&G:n
              palvelukeskuksista.
            </li>
            <li>
              Määräaika sähköisen rekisteröintilomakkeen lähettämiselle ja
              ostokuitin lataamiselle on <b>30.10.2026</b>. Tukiosastomme on
              tavoitettavissa <b>19.12.2026</b> asti.
            </li>
          </ul>
        </div>
        <br />
        <div>
          Kiitos kiinnostuksestasi Oral-B Moneyback -takuu. Vaikka yritimme
          antaa sinulle kaiken olennaisen yhdellä silmäyksellä: Se on hieman
          monimutkaisempaa. Siksi löydät myös "pienellä painettua tekstiä"
          näissä ehdot ja edellytykset.
        </div>
        <ul class="list" ref="list">
          <li class="list-item-wrapper">
            <div class="number">Ketkä osallistuvat kampanjaan?</div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanjan järjestää Norjassa, Tanskassa, Ruotsissa ja
                  Suomessa asuville osallistujille Procter &amp; Gamble
                  International Operations SA, Route de Saint-Georges 47, 1213
                  PETIT-LANCY, Geneve.</span
                >
              </p>
              <p class="western"></p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"><strong>Mistä kampanjassa on kyse?</strong></span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanja antaa sinulle mahdollisuuden kokeilla ja palauttaa
                  tietyt Oral-B-tuotteet 60 päivän kuluessa. Seuraavat tuotteet
                  ("</span
                ><span lang="en"><strong>Myynninedistämistuotteet</strong></span
                ><span lang="en">") osallistuvat tähän kampanjaan:</span>
              </p>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="217" />
                        <col width="87" />
                      </colgroup>
                      <colgroup>
                        <col width="198" />
                        <col width="104" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="217" height="21">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 1</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238331</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307327</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 3</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201291947</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Violet UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307389</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 5</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238492</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S White UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307556</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201309512</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307594</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="220" />
                        <col width="84" />
                      </colgroup>
                      <colgroup>
                        <col width="222" />
                        <col width="81" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality Kids Spiderman CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201320074</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 S Rose Quartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307631</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Mandalorian CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201386230</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 Duo White UC / Black UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201315766</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox +
                                TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201309444</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO6 White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377665</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Star wars CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241201</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Grey Opal UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377788</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241317</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Pink Sand GC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378143</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241331</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo White UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378198</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Star Wars</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307105</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2400N Black SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258117</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Frozen</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307242</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2400N Pink SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258544</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Starter Pack Turquiose CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201260899</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258643</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241379</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2200S Blue SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274681</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 680 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235811</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2900 Black CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271598</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Star Wars Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396109</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2700 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201179078</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Minnie Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396123</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 White SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201249924</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3400N Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291053</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro2 2500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319412</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3400N Pink Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291077</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro2 2500 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319313</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3200S Blue Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291091</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178682</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro3 3000 PureClean</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201365280</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Oral B Clean &amp; Protect Pro 2 Black
                                CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201396000</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3300W White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291114</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2000 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201267782</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 890 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235941</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2000 Pink CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178736</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3900N White Sens +Black Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291503</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO 6N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201409113</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3950N Black CA + Pink CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291374</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO7 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307181</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4900 White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201271611</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Black UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307433</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20400N Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201272922</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Violet UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307464</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201276869</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307570</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20200S RoseGold SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201274858</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 N RoseQuartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307617</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199441</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307532</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199472</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo Black UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411536</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 170 Blue CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201201038</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO9 Duo Black UC / Rose Quartz UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411550</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Junior Green SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202318</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 1</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238355</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Junior Purple SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202332</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 2</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238454</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 760 Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201137191</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 3</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238515</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 700 Turquoise CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201124092</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GENIUS 10 GUM CARE</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271864</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 700 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201157786</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Pixar Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201314592</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 750 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201319399</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 150 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201200772</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 750 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312499</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Star Wars SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245780</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro1 750 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312291</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Minnie SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245896</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 1 800 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201077596</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255277</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 900 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201187370</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274728</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p><span lang="en">Oral-B Pro3 3700 CA</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291176</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 5000N White CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203315</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 3000 CA Black Edition</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289364</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255499</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3000 White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289470</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274773</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289517</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B GENIUS 8 8100S WHITE SU</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201261414</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3500 WT Sensi</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289562</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Blush Pink SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201279785</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 970 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201207955</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4000N White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203377</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396697</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 4 4500 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201312536</span></p>
                          </td>
                        </tr>
                        <!-- NEW ADDED JSDEV-17782 -->
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro Clean White + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540757802</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Pro1 Duo Black / Turquoise</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090915016</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Pink + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914217</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Black + TC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090914170</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Turquoise + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914132</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Black + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771457</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro1 Turquoise + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540771914</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Pink + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771501</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral B Clean & Protect Pro 2 Black CA
                              </span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396024</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head + TC
                              </span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759912</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759929</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759868</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759790</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Pink + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540802083</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Blue + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759813</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760857</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760918</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro3 Duo Black / White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760765</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro3 Duo Black / Pink</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760277</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Matt Black</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730898</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO3S Ice Blue</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540730935</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Blush Pink</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730843</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >iO3 Duo Matt Black / Ice Blue</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540731659</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO10 Stardust White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201435624</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO10 Cosmic Black</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201435648</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Laboratory Clean 1</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772119</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Laboratory Clean 3 +1 refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760345</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO Laboratory Clean 5</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201445098</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773178</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772645</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540772409</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540773390</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773659</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772768</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Junior 6+ Green</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540743027</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Junior 6+ Purple </span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540742891</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Pro 3 Junior 6+ Star Wars</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540957196</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro 3 Junior 6+ Frozen</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540774724</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Vitality Pro Lilac CA HBOX</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201426967</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Vitality Pro Black CA HBOX</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201427063</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201446392</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Black CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201432326</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Lilac CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201432340</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201446491</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="606" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="227" />
                        <col width="76" />
                      </colgroup>
                      <colgroup>
                        <col width="223" />
                        <col width="80" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="227" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive WT Sensi + TC</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201396673</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8600 Silver SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201261506</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5900 Black + White CA</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201180074</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8500 Silver CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201314530</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="sv-SE"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20900 RoseG SUT/Black CA
                                Black</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201276982</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S White SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247166</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Pink CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200710</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Blush Pink SUT Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295358</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Black CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200758</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Black CA Black Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295402</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p><span lang="en">Oral-B iO7 S White UC</span></p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201306702</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en">Oral-B Smart 6 6600 Blue CA</span>
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203292</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en">Oral-B iO7S Black Onyx UCB</span>
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201364733</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8200W White CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203179</span></p>
                          </td>
                        </tr>
                        <template v-for="(item, idx) in newProducts">
                          <tr v-if="idx % 2 === 0" :key="idx">
                            <td width="227" height="20">
                              <p>
                                <span lang="en">{{ item.name }}</span>
                              </p>
                            </td>
                            <td width="76">
                              <p>
                                <span lang="en">{{ item.ean }}</span>
                              </p>
                            </td>
                            <td width="223">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].name
                                    : ""
                                }}</span>
                              </p>
                            </td>
                            <td width="80">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].ean
                                    : ""
                                }}</span>
                              </p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <p class="western">
                <span lang="en"><strong>HUOMAUTUS:</strong></span
                ><span lang="en">
                  Sinun on rekisteröitävä kuittisi ja tuotteesi
                  verkkosivustollamme
                  <a href="https://www.oral-b-moneyback.com/fi"
                    >www.oral-b-moneyback.com
                  </a>
                  <b>60 päivän</b> kuluessa ostosta. Kun olet saanut
                  vahvistuksen online-rekisteröinnistä, sinulla on </span
                ><span lang="en"><strong>10 päivää </strong></span
                ><span lang="en"
                  >aikaa lähettää tuotteesi yhdessä vahvistussähköpostisi
                  liitteenä olevan palautuslomakkeen kanssa johonkin alla
                  luetelluista P&amp;G:n palvelukeskuksista.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Palautus vastaa tosiasiallisesti maksettua ostohintaa.</span
                >
                <br /><br />
                <span lang="en">Kampanja koskee</span>
              </p>
              <ul>
                <li>
                  <p>
                    <span lang="en">kampanjatuotteiden ostoihin</span
                    ><span lang="en"
                      ><strong>01.07.2025 ja 31.08.2026 </strong></span
                    ><span lang="en">välisenä aikana.</span>
                    <span lang="en"><strong>("kampanja-aika") </strong></span>
                    <span lang="en"
                      >ostotodistuksen päivämäärä on merkityksellinen;</span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >ostoksiin - myös verkko-ostoksiin - vähittäismyyjältä
                      "(</span
                    ><span lang="en"
                      ><strong>kampanjan jälleenmyyjät</strong></span
                    ><span lang="en">") ;</span>
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >ei nimenomaisesti koske kampanjatuotteiden
                      "yksityisostoja", mukaan lukien verkossa/
                      huutokauppapaikat</span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Kuka voi osallistua kampanjaan?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en">Voit osallistua kampanjaan, jos</span>
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >olet loppukäyttäjä ja yli 18-vuotias ja asut Norjassa,
                        Tanskassa, Ruotsissa tai Suomessa,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >sinulla on pankkitili, jonka IBAN-tilinumero on
                        osoitettu johonkin Euroopan maahan,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >sinulla on oltava sähköpostiosoite ja</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >sinulla on pääsy kampanjan verkkosivustolle osoitteessa
                        <a href="https://www.oral-b-moneyback.com/fi"
                          >www.oral-b-moneyback.com</a
                        >.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Kukin IBAN-tilinumero ja sähköpostiosoite yhdistetään
                  käyttäjätiliksi, ja ne voivat osallistua kampanjaan vain
                  yhdellä yhdistelmällä.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Miten voit osallistua kampanjaan?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Osallistuaksesi kampanjaan sinun on täytettävä seuraavat
                  vaatimukset</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >ostanut osallistuvan tuotteen vähittäiskaupasta
                        kampanja-aikana sekä omistettava ostettu osallistuva
                        tuote ja ostotodistus,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >avaa verkkolomake
                        <a
                          style="color: #6eac1c"
                          href="https://www.oral-b-moneyback.com/fi"
                          >www.oral-b-moneyback.com</a
                        >,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ilmoita kampanjatuotteen viivakoodin numero tai lataa
                        kuva kampanjatuotteen viivakoodista,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en">lataa valokuva ostotodistuksesta,</span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >lataa valokuva tuotteen kyljestä, jossa on
                        viivakoodi,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >anna tilitietosi (IBAN, BIC, tilinomistajan etu- ja
                        sukunimi),</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >rekisteröidy antamalla sähköpostiosoitteesi ja muut
                        henkilökohtaiset tietosi sekä</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >täytä kampanjasivustolla (ks. jäljempänä) esitetyt
                        todentamis- ja väärinkäytösten/petosten estämisvaiheet.
                        Klikkaamalla painiketta osallistumisen
                        loppuunsaattamiseksi hyväksyt myös nämä ehdot ja
                        edellytykset.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western"></p>
              <p class="western">
                <span lang="en"
                  >Online-osallistumisprosessin onnistunut loppuunsaattaminen ja
                  osallistumisesi viitenumero näytetään
                  kampanjasivustolla.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Tämän jälkeen sinun on lähetettävä tuote yhdessä vastaavan
                  kupongin kanssa palvelukeskukseen</span
                ><span lang="en"><strong> 10 päivän </strong></span
                ><span lang="en">
                  kuluessa. Saat hyvityksesi 6 viikon kuluessa siitä, kun
                  paketti on saapunut ja vahvistettu P&amp;G
                  palvelukeskuksessa.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >ähköinen online-osallistumisprosessi on saatettava </span
                ><span lang="en"><strong> 60 päivän </strong></span
                ><span lang="en">
                  kuluessa ostosta. Määräaika sähköisen rekisteröintilomakkeen
                  lähettämiselle ja ostokuitin lataamiselle on </span
                ><span lang="en"
                  ><strong>30.10.2026 ("Päättymispäivä").</strong></span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Vain rekisteröidyt paketit, joissa on voimassa oleva
                  seurantanumero, voidaan hyväksyä palautettavaksi. Postikuluja
                  ei palauteta.</span
                >
              </p>
              <p class="western">
                <span lang="en"><strong>P&amp;G Palvelukeskuksen </strong></span
                ><span lang="en">osoitteet maassasi ovat:</span>
              </p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Norja</strong></span>
              </h1>
              <p class="western"><span lang="en">L.G. Elektro A/S</span></p>
              <p class="western"><span lang="en">Kolstien 4</span></p>
              <p class="western"><span lang="en">5097 Bergen</span></p>
              <p class="western"><span lang="en">Norge</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Ruotsi</strong></span>
              </h1>
              <p class="western">
                <span lang="en">El &amp; Digital Service AB</span>
              </p>
              <p class="western"><span lang="en">Folkungagatan 144</span></p>
              <p class="western"><span lang="en">116 30 Stockholm</span></p>
              <p class="western"><span lang="en">Sverige</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Suomi</strong></span>
              </h1>
              <p class="western"><span lang="en">AIDE Europe Oy</span></p>
              <p class="western"><span lang="en">Haukilahdenkatu 4</span></p>
              <p class="western"><span lang="en">FI-00550 Helsinki</span></p>
              <p class="western"><span lang="en">Suomi</span></p>
              <h1 class="western">
                <span lang="en"><strong>Tanska</strong></span>
              </h1>
              <p class="western"><span lang="en">CJ Hvidevareservice</span></p>
              <p class="western"><span lang="en">Thorndahlsvej 11</span></p>
              <p class="western"><span lang="en">9200 Aalborg SV</span></p>
              <p class="western"><span lang="en">Danmark</span></p>
              <p class="western">
                <span lang="en"
                  >Huomioi seuraavat tiedot osallistumiseen vaadittavan
                  kampanjatuotteen viivakoodin ja ostotodistuksen osalta:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Varmista, että viivakoodi (eli tavallinen mustista
                        viivoista ja valkoisista väleistä koostuva viivakoodi)
                        näkyvät selvästi vastaavissa tuotekuvissa.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Näissä ehdot ja edellytykset tarkoitettuna
                        ostotodistuksena kelpaa ainoastaan kampanjaan
                        osallistuvan jälleenmyyjän kuitti tai lasku.
                        Tilausvahvistukset, toimituskirjat tai vastaavat
                        asiakirjat eivät riitä.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ostotodisteen kuvassa on oltava selvästi
                        tunnistettavissa jälleenmyyjän tiedot, kuitin tunnus (ei
                        pankkitapahtuman tunnus), kuitin päivämäärä ja
                        kellonaika, myynninedistämistuote,
                        myynninedistämistuotteen hinta ja kuitin kokonaissumma,
                        ilmoitettu arvonlisävero ja mahdolliset myönnetyt
                        alennukset.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ostotositteen kuva ei saa olla ylivalottunut, epätarkka
                        tai liian tumma. Skannatut kuitit eivät riitä
                        osallistumiseen, vaan niistä vaaditaan yksityiskohtaiset
                        valokuvat.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ostotodistuksen valokuvassa saa esittää vain
                        ostotodistuksen; ostettua kampanjatuotetta ei saa kuvata
                        yhdessä ostotodistuksen kanssa.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Osallistumisprosessin onnistunut loppuunsaattaminen - eli
                  kaikkien antamiesi tai lataamiesi tietojen vastaanottaminen -
                  sekä osallistumisesi viitenumero näkyvät kampanjasivustolla;
                  saat myös sähköpostiviestin antamaasi
                  sähköpostiosoitteeseen.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Mitä muuta on otettava huomioon?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"><u>Testikampanja:</u></span
                ><span lang="en">
                  Tämän kampanjan avulla voit testata Oral-B-tuotteita. Tätä
                  taustaa vasten (ja vastaavista toimista saatujen kokemusten
                  perusteella) meidän on määriteltävä joitakin pelisääntöjä
                  kampanjan tavoitteen osalta:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Kampanjaan voi osallistua vain omissa nimissäsi ja
                        henkilöä kohden 5 ostotodistuksella ja 5
                        kampanjatuotteella.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Kutakin ostotodistusta voi käyttää vain kerran
                        kampanjaan osallistumiseen; tämä pätee myös, jos
                        ostotositteessa näkyy enemmän kuin 5 osallistuvaa
                        tuotetta.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Jos lunastat samalla kampanjatuotteen alennuskupongin,
                        saat Justsnapilta hyvityksen vain todellisuudessa
                        maksetusta summasta.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Tuotteesta, joka on jo osallistunut johonkin toiseen
                        kampanjaan, voidaan korvata tämän kampanjan osalta vain
                        tuotteen todellinen hinta. Jos siis saat 10EUR/100KR tai
                        20EUR/200KR Oral-B:n rahat takaisin kampanjassa,
                        vastaava summa vähennetään palautuksestasi Money Back
                        -kampanjassa. Tässä kampanjassa palautettua tuotetta ei
                        voi käyttää missään muussa Procter &amp; Gamble
                        -kampanjassa.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Lisäksi kukin IBAN ja sähköpostiosoite yhdistetään
                        käyttäjätiliksi, ja ne voivat osallistua kampanjaan vain
                        samalla yhdistelmällä.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >IBAN-numeron virheellisestä ilmoittamisesta ei oteta
                        vastuuta. Virheellisen IBAN-tilinumeron voi muuttaa
                        kerran, minkä jälkeen osallistuminen raukeaa. Jos haluat
                        muuttaa pankkitietojasi, voit ottaa yhteyttä
                        tukipalveluumme, joka on perustettu yksinomaan
                        IBAN-muutoksia varten (sähköpostitse:
                        <a
                          style="color: #6eac1c"
                          href="mailto:support@oral-b-moneyback.com"
                          >:</a
                        ></span
                      ><a
                        style="color: #6eac1c"
                        href="mailto:support@oral-b-moneyback.com"
                        ><span lang="en"
                          ><u>support@oral-b-moneyback.com</u></span
                        ></a
                      ><span lang="en">) </span
                      ><span lang="en"><strong>19.12.2026</strong></span
                      ><span lang="en">
                        asti. (Jos sinulla on kysymyksiä, jotka eivät liity
                        IBAN-tilinumeron muuttamiseen, ota meihin yhteyttä
                        kohdassa I annettujen yhteystietojen avulla).</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Puutteellisia, virheellisiä tai myöhästyneitä
                        hakemuksia ei voi palauttaa. Lähettäjätodistusta ei
                        hyväksytä vastaanottotodistukseksi. Emme ole vastuussa
                        lomakkeista ja/tai niiden sisällöstä, jotka ovat
                        kadonneet, vahingoittuneet tai viivästyneet.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Jos pakkauksen sisältö on lähetetty väärin,
                        kuluttajalla on kerran mahdollisuus lähettää tarvittavat
                        asiakirjat uudelleen. Jos toisella yrittämällä jokin
                        sisältö puuttuu tai on jälleen virheellinen,
                        osallistuminen mitätöityy.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  ><u>Väärinkäytösten ja petosten ehkäiseminen:</u></span
                ><span lang="en">
                  Tähänastisen kokemuksemme mukaan tällaiset kampanjat johtavat
                  valitettavasti säännöllisesti väärinkäyttö- ja
                  petosyrityksiin, joskus huomattavassa määrin. Tästä syystä
                  meidän on myös tässä kampanjassa ryhdyttävä erilaisiin
                  toimenpiteisiin tällaisten yritysten estämiseksi ja
                  havaitsemiseksi. Ymmärrämme, että tämä saattaa aiheuttaa
                  teille lisätyötä. Olemme kuitenkin pyrkineet tekemään
                  tarvittavista toimistamme mahdollisimman mutkattomia sinulle
                  osallistujana:</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Edellä kohdassa D selostetun tarkistuksen avulla
                        tarkistamme osana osallistumisprosessia, onko
                        osallistujan antamia tietoja (IBAN-tilinumero ja
                        sähköpostiosoite) jo käytetty kampanjaan
                        osallistumiseen; tässä tapauksessa kukin IBAN-tilinumero
                        yhdessä sähköpostiosoitteen kanssa luo käyttäjätilin, ja
                        tämä yhdistelmä ei saa olla erilainen useamman
                        osallistumisen yhteydessä.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Jatkokäsittelyn aikana tarkistetaan myös osallistujan
                        tiedot, erityisesti osallistujien lataamat viivakoodit
                        ja ostotodisteet.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"><u>Ostotodistuksen säilyttäminen:</u></span
                ><span lang="en"> Huomaa, että sinun on </span
                ><span lang="en"
                  ><u
                    >säilytettävä osallistumiseen käytetty alkuperäinen
                    ostotodistus siihen asti, kunnes palautus on saatu.</u
                  ></span
                ><span lang="en">
                  Yksittäistapauksissa sinun on lähetettävä se postitse
                  tarkistettavaksi, ennen kuin palautus voidaan myöntää. Tässä
                  tapauksessa lähetä alkuperäinen ostotodistus kirjekuoressa,
                  jossa on riittävä postimaksu, annettuun osoitteeseen.
                  Postimerkitsemättömiä lähetyksiä ei hyväksytä, eikä
                  alkuperäistä ostotodistusta voida palauttaa sen tarkistamisen
                  jälkeen (ota tarvittaessa kopio omiin tarpeisiisi); emme
                  vastaa postitse tapahtuvasta katoamisesta.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Mitä tapahtuu osallistumisen jälkeen?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western"><span lang="en">Tässä yhteydessä</span></p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Tarkastus suoritetaan väärinkäytösten ja petosten
                        estämiseksi. Tässä yhteydessä sinulta voidaan
                        yksittäistapauksissa pyytää alkuperäinen
                        ostotodistus;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Rahasaatavasi vahvistamiseksi lähetetään sähköposti
                        antamaasi sähköpostiosoitteeseen; tämä tapahtuu yleensä
                        kahden työpäivän kuluessa tietojen
                        vastaanottamisesta;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >P&amp;G:n palvelukeskus vahvistaa paketin, jossa on
                        osallistuva tuote ja</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Palautuksen määrä maksetaan IBAN-tilin kautta
                        ilmoittamallesi tilille; tämä tapahtuu yleensä kuuden
                        viikon kuluessa kokeen suorittamisesta.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Pidätämme oikeuden sulkea minkä tahansa osallistujan pois
                  kampanjasta, jos epäillään, että osallistumisen yhteydessä on
                  annettu vääriä tietoja, kampanjaa on yritetty manipuloida tai
                  näitä ehtoja on muutoin rikottu. Tässä tapauksessa sinulle ei
                  lähetetä vahvistussähköpostia. Voit todistaa meille, että
                  sinun tapauksessasi ei ole rikottu ehdot ja
                  edellytykset.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Pidätämme myös oikeuden muuttaa tai mukauttaa näitä
                  käyttöehtoja ja keskeyttää, pidentää tai lopettaa kampanjan
                  milloin tahansa ilman ennakkoilmoitusta.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Norjasta tuleviin osallistujiin sovelletaan Norjan lakia,
                  Ruotsista Ruotsin lakia, Suomesta Suomen lakia ja Tanskasta
                  Tanskan lakia. Tuomareiden päätös on lopullinen.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong
                  >Keneen voin ottaa yhteyttä, jos minulla on kysyttävää
                  kampanjasta?</strong
                ></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Jos sinulla on kysyttävää kampanjasta, nopein ja ainoa tapa
                  ottaa meihin yhteyttä on
                  <a href="mailto:contact@oral-b-moneyback.com"
                    >contact@oral-b-moneyback.com</a
                  >. Tämä mahdollisuus on olemassa </span
                ><span lang="en"><strong>19.12.2026</strong></span
                ><span lang="en"> asti.</span>
              </p>
              <p class="western">
                <span lang="en"
                  >Voit ottaa yhteyttä Procter &amp; Gamble International
                  Operations SA:han myös sähköpostitse
                  <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com </a
                  >ja postitse (Route de Saint-Georges 47 1213 PETIT-LANCY,
                  Geneve).</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale == 'no'">
        <h1 class="page-title">Vilkår og betingelser</h1>
        <h2 class="page-title">Oral-B Penge tilbage Garanti</h2>
        <br />
        <div class="text-center mb-5 w-100">
          <div style="font-style: italic">
            Prøv produktet vårt og få pengene tilbake
          </div>
          <br />
          <hr />
          <br />
          <div style="font-style: italic">
            Liker du ikke produktet du kjøpte? – Ikke noe problem, registrer
            deg, returner produktet og få pengene tilbake!
          </div>
        </div>
        <br />
        <b>Kampanjen på et øyeblikk:</b>
        <div class="box-notice">
          <ul>
            <li>
              Kjøp Oral-B deltakende produkter i løpet av deltakerperioden
              (mellom <b>01.07.2025</b> og <b>31.08.2026</b>) hos en forhandler.
            </li>
            <li>
              Registrer deg på salgsfremmende nettstedet, last opp kjøpsbeviset
              for salgsfremmende produktet og send inn registreringsskjemaet.
              Etter å ha sjekket, vil du motta en e-post med detaljer for
              produktretur. Etter at produktet ble mottatt sammen med alle
              nødvendige dokumenter, vil du få refusjon for det returnerte
              produktet via bankoverføring. Ta vare på det opprinnelige
              kjøpsbeviset!
            </li>
            <li>
              Deltakelse i kampanjen er kun mulig i eget navn og per person med
              <b>maksimalt 5 kjøpsbevis</b> kjøpsbevis og
              <b>5 deltakende produkter</b> totalt.
            </li>
            <li>
              Hvert købsbevis kan kun bruges én gang. Hvis du ønsker at
              returnere mere end ét produkt fra ét købsbevis, skal du returnere
              alle produkterne på én gang.
            </li>
            <li>
              <b>Viktig</b>: Du må registrere kvitteringen og produktet via
              nettstedet vårt www.oral-b-moneyback.com innen
              <b>60 dager etter kjøpet</b>. Så snart din online deltakelse er
              bekreftet, vil du ha <b>10 dager</b> på deg til å skrive ut
              returskjemaet og sende det sammen med produktet ditt til et av
              P&amp;G-servicesentrene som er oppført i disse vilkårene og
              betingelsene.
            </li>
            <li>
              Fristen for å sende inn det elektroniske registreringsskjemaet og
              laste opp kjøpskvitteringen er <b>30.10.2026</b>. Vår
              supportavdeling er tilgjengelig frem til <b>19.12.2026</b>.
            </li>
          </ul>
        </div>
        <br />
        <div>
          Takk for din interesse for vårt Oral-B Penge tilbage Garanti. Selv om
          vi prøvde å gi deg alt det viktigste på et øyeblikk: Det er litt mer
          komplisert. Du vil derfor også finne "liten skrift" i disse vilkårene
          og betingelsene.
        </div>
        <ul class="list" ref="list">
          <li class="list-item-wrapper">
            <div class="number">Hvem er involvert i kampanjen?</div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanjen er organisert for deltakere bosatt i Norge,
                  Danmark, Sverige og Finland av Procter &amp; Gamble
                  International Operations SA, Route de Saint-Georges 47, 1213
                  PETIT-LANCY, Geneve.</span
                >
              </p>
              <p class="western"></p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"><strong>Hva handler kampanjen om?</strong></span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanjen gir deg muligheten til å prøve å returnere visse
                  Oral-B-produkter innen 60 dager. Følgende produkter </span
                ><span lang="en">. Følgende produkter ("</span
                ><span lang="en"><strong>Aktuelle produkter</strong>")</span
                ><span lang="en"> deltar i denne kampanjen:</span>
              </p>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="217" />
                        <col width="87" />
                      </colgroup>
                      <colgroup>
                        <col width="198" />
                        <col width="104" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="217" height="21">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 1</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238331</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307327</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 3</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201291947</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Violet UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307389</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 5</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238492</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S White UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307556</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201309512</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307594</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="220" />
                        <col width="84" />
                      </colgroup>
                      <colgroup>
                        <col width="222" />
                        <col width="81" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality Kids Spiderman CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201320074</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 S Rose Quartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307631</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Mandalorian CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201386230</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 Duo White UC / Black UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201315766</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox +
                                TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201309444</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO6 White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377665</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Star wars CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241201</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Grey Opal UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377788</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241317</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Pink Sand GC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378143</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241331</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo White UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378198</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Star Wars</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307105</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2400N Black SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258117</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Frozen</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307242</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2400N Pink SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258544</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Starter Pack Turquiose CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201260899</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258643</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241379</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2200S Blue SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274681</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 680 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235811</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2900 Black CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271598</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Star Wars Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396109</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2700 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201179078</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Minnie Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396123</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 White SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201249924</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3400N Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291053</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro2 2500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319412</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3400N Pink Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291077</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro2 2500 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319313</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3200S Blue Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291091</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178682</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro3 3000 PureClean</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201365280</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Oral B Clean &amp; Protect Pro 2 Black
                                CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201396000</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3300W White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291114</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2000 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201267782</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 890 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235941</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2000 Pink CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178736</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3900N White Sens +Black Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291503</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO 6N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201409113</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3950N Black CA + Pink CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291374</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO7 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307181</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4900 White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201271611</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Black UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307433</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20400N Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201272922</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Violet UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307464</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201276869</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307570</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20200S RoseGold SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201274858</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 N RoseQuartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307617</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199441</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307532</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199472</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo Black UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411536</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 170 Blue CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201201038</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO9 Duo Black UC / Rose Quartz UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411550</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Junior Green SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202318</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 1</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238355</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Junior Purple SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202332</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 2</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238454</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 760 Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201137191</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 3</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238515</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 700 Turquoise CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201124092</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GENIUS 10 GUM CARE</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271864</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 700 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201157786</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Pixar Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201314592</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 750 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201319399</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 150 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201200772</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 750 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312499</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Star Wars SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245780</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro1 750 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312291</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Minnie SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245896</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 1 800 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201077596</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255277</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 900 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201187370</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274728</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p><span lang="en">Oral-B Pro3 3700 CA</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291176</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 5000N White CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203315</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 3000 CA Black Edition</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289364</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255499</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3000 White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289470</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274773</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289517</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B GENIUS 8 8100S WHITE SU</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201261414</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3500 WT Sensi</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289562</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Blush Pink SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201279785</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 970 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201207955</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4000N White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203377</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396697</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 4 4500 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201312536</span></p>
                          </td>
                        </tr>
                        <!-- NEW ADDED JSDEV-17782 -->
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro Clean White + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540757802</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Pro1 Duo Black / Turquoise</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090915016</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Pink + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914217</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Black + TC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090914170</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Turquoise + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914132</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Black + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771457</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro1 Turquoise + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540771914</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Pink + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771501</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral B Clean & Protect Pro 2 Black CA
                              </span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396024</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head + TC
                              </span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759912</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759929</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759868</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759790</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Pink + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540802083</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Blue + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759813</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760857</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760918</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro3 Duo Black / White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760765</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro3 Duo Black / Pink</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760277</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Matt Black</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730898</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO3S Ice Blue</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540730935</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Blush Pink</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730843</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >iO3 Duo Matt Black / Ice Blue</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540731659</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO10 Stardust White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201435624</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO10 Cosmic Black</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201435648</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Laboratory Clean 1</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772119</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Laboratory Clean 3 +1 refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760345</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO Laboratory Clean 5</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201445098</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773178</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772645</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540772409</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540773390</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773659</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772768</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Junior 6+ Green</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540743027</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Junior 6+ Purple </span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540742891</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Pro 3 Junior 6+ Star Wars</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540957196</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro 3 Junior 6+ Frozen</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540774724</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Vitality Pro Lilac CA HBOX</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201426967</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Vitality Pro Black CA HBOX</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201427063</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201446392</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Black CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201432326</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Lilac CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201432340</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201446491</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="606" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="227" />
                        <col width="76" />
                      </colgroup>
                      <colgroup>
                        <col width="223" />
                        <col width="80" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="227" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive WT Sensi + TC</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201396673</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8600 Silver SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201261506</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5900 Black + White CA</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201180074</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8500 Silver CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201314530</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="sv-SE"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20900 RoseG SUT/Black CA
                                Black</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201276982</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S White SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247166</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Pink CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200710</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Blush Pink SUT Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295358</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Black CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200758</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Black CA Black Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295402</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p><span lang="en">Oral-B iO7 S White UC</span></p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201306702</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en">Oral-B Smart 6 6600 Blue CA</span>
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203292</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en">Oral-B iO7S Black Onyx UCB</span>
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201364733</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8200W White CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203179</span></p>
                          </td>
                        </tr>
                        <template v-for="(item, idx) in newProducts">
                          <tr v-if="idx % 2 === 0" :key="idx">
                            <td width="227" height="20">
                              <p>
                                <span lang="en">{{ item.name }}</span>
                              </p>
                            </td>
                            <td width="76">
                              <p>
                                <span lang="en">{{ item.ean }}</span>
                              </p>
                            </td>
                            <td width="223">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].name
                                    : ""
                                }}</span>
                              </p>
                            </td>
                            <td width="80">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].ean
                                    : ""
                                }}</span>
                              </p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <p class="western">
                <span lang="en"><strong>MERK</strong>:</span
                ><span lang="en">
                  Du må registrere kvitteringen og produktet via nettstedet vårt
                  <a href="https://www.oral-b-moneyback.com/no"
                    >www.oral-b-moneyback.com </a
                  >innen <span lang="en"><strong>60 dager</strong></span> .
                  Etter bekreftelse av den elektroniske registreringen, vil du
                  ha </span
                ><span lang="en"><strong>10 dager</strong></span
                ><span lang="en">
                  på deg til å sende produktet sammen med returskjemaet vedlagt
                  bekreftelses-e-posten din til et av P&amp;G-servicesentrene
                  som er oppført nedenfor.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Refusjonen tilsvarer kjøpesummen som faktisk er betalt.
                </span>
                <span lang="en">Kampanjen er relatert til </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span lang="en">til kjøp av kampanjeprodukter mellom</span
                    ><span lang="en"><strong>01.07.2025 </strong></span
                    ><span lang="en">og </span
                    ><span lang="en"><strong>31.08.2026 </strong></span
                    ><span lang="en">("</span
                    ><span lang="en"><strong>Kampanjeperiode</strong></span
                    ><span lang="en">"), er kjøpsdatoen relevant;</span>
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >til kjøp - inkludert online kjøp - fra en forhandler ("
                      <span lang="en"><strong>Kampanjeperiode</strong></span
                      ><span lang="en">");</span></span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >eksplisitt ikke til "private kjøp" av salgsfremmende
                      produkter, inkludert online / auksjon plattforme.</span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Hvem kan delta i kampanjen?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en">Du kan delta i kampanjen hvis du</span>
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >er sluttbruker og over 18 år og bor i Norge, Danmark,
                        Sverige eller Finland,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ha en bankkonto med en IBAN tilordnet et europeisk
                        land,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p><span lang="en">har en e-postadresse og</span></p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >kan få tilgang til kampanjenettstedet på
                        <a href="https://www.oral-b-moneyback.com/no"
                          >www.oral-b-moneyback.com</a
                        >.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Hver IBAN- og e-postadresse kombineres til en brukerkonto og
                  kan bare delta i hele kampanjen i én kombinasjon.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Hvordan kan du delta i kampanjen?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en">For å delta i kampanjen må du</span>
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >har kjøpt et deltakende produkt i detaljhandelen i
                        løpet av kampanjeperioden, samt besittet det kjøpte
                        deltakende produktet og kjøpsbeviset,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >åpne det elektroniske skjemaet
                        <a href="https://www.oral-b-moneyback.com/no"
                          >www.oral-b-moneyback.com</a
                        >,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >oppgi strekkodenummeret til salgsfremmende produktet
                        eller laste opp et bilde av strekkoden til
                        salgsfremmende produktet ditt,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >laste opp et bilde av kjøpsbeviset ditt,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >laste opp et bilde av produktsiden med
                        strekkoden,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >oppgi kontoinformasjonen din (IBAN, BIC, for- og
                        etternavn til kontoinnehaveren),</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >registrere deg ved å oppgi e-postadresse og annen
                        personlig informasjon og</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >fullfør trinnene for verifisering og misbruk /
                        forebygging av svindel som vises på kampanjenettstedet
                        (se nedenfor). Ved å klikke på knappen for å fullføre
                        deltakelsen din, godtar du også disse vilkårene og
                        betingelsene.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western"></p>
              <p class="western">
                <span lang="en"
                  >Den vellykkede fullføringen av den elektroniske
                  deltakelsesprosessen og referansenummeret for deltakelsen din
                  vises på kampanjenettstedet.
                </span>
              </p>
              <p class="western">
                <span lang="en"
                  >Etter det må du sende produktet sammen med den tilsvarende
                  kupongen til servicesenteret innen </span
                ><span lang="en"><strong>10 dager</strong></span
                ><span lang="en"
                  >. Du vil motta refusjonen innen 6 uker etter at pakken
                  ankommer og er bekreftet i P&G servicesenteret.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Den elektroniske deltakelsesprosessen må fullføres innen </span
                ><span lang="en"><strong>60 dager etter kjøpet</strong></span
                ><span lang="en"
                  >Fristen for å sende inn det elektroniske
                  registreringsskjemaet og laste opp kjøpskvitteringen er
                  <strong>30.10.2026</strong> ("</span
                ><span lang="en"><strong>Avslutningsdato</strong></span
                ><span lang="en">").</span>
              </p>
              <p class="western">
                <span lang="en"
                  >Kun registrerede pakker med gyldigt trackingnummer kan
                  accepteres. Portoudgifterne refunderes ikke.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  ><strong>P&amp;G Servicesenter</strong> adresser i ditt land
                  er:</span
                >
              </p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Norge</strong></span>
              </h1>
              <p class="western"><span lang="en">L.G. Elektro A/S</span></p>
              <p class="western"><span lang="en">Kolstien 4</span></p>
              <p class="western"><span lang="en">5097 Bergen</span></p>
              <p class="western"><span lang="en">Norge</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Sverige</strong></span>
              </h1>
              <p class="western">
                <span lang="en">El &amp; Digital Service AB</span>
              </p>
              <p class="western"><span lang="en">Folkungagatan 144</span></p>
              <p class="western"><span lang="en">SE-116 30 Stockholm</span></p>
              <p class="western"><span lang="en">Sverige</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Finland</strong></span>
              </h1>
              <p class="western"><span lang="en">AIDE Europe Oy</span></p>
              <p class="western"><span lang="en">Haukilahdenkatu 4</span></p>
              <p class="western"><span lang="en">FI-00550 Helsinki</span></p>
              <p class="western"><span lang="en">Suomi</span></p>
              <h1 class="western">
                <span lang="en"><strong>Danmark</strong></span>
              </h1>
              <p class="western"><span lang="en">CJ Hvidevareservice</span></p>
              <p class="western"><span lang="en">Thorndahlsvej 11</span></p>
              <p class="western"><span lang="en">DK-9200 Aalborg SV</span></p>
              <p class="western"><span lang="en">Danmark</span></p>
              <p class="western">
                <span lang="en"
                  >Vær oppmerksom på følgende med hensyn til strekkoden til
                  salgsfremmende produktet som kreves for deltakelse og
                  kjøpsbevis:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Forsikre deg om at strekkoden (dvs. den vanlige
                        strekkoden som består av svarte stolper med hvite
                        mellomrom) er tydelig synlig på de tilsvarende
                        produktbildene.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Som kjøpsbevis i betydningen av disse vilkår og
                        betingelser, er bare kvitteringen eller fakturaen fra
                        kampanjeforhandleren gyldig. Ordrebekreftelser,
                        leveringsmerknader eller sammenlignbare dokumenter er
                        ikke tilstrekkelige.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >På bildet av kjøpsbeviset må detaljene til
                        forhandleren, kvitterings-ID-en (ikke
                        banktransaksjons-ID), dato og klokkeslett for
                        kvitteringen, kampanjeproduktet, prisen på
                        kampanjeproduktet og det totale beløpet for
                        kvitteringen, den oppgitte mva og eventuelle rabatter
                        som gis være tydelig gjenkjennelige.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Bildet av kjøpsbeviset må ikke være overeksponert,
                        uskarpt eller for mørkt. Skannede kvitteringer er ikke
                        tilstrekkelig for deltakelse, detaljerte bilder er
                        nødvendig.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Bare kjøpsbeviset kan vises på bildet av kjøpsbeviset;
                        det kjøpte salgsfremmende produktet kan ikke
                        fotograferes sammen med kjøpsbeviset.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Vellykket gjennomføring av deltakelsesprosessen - det vil si
                  fordring av all informasjon du har oppgitt eller lastet opp -
                  samt referansenummeret til deltakelsen din vil bli vist på
                  kampanjenettstedet; Du vil da også motta en e-post til
                  e-postadressen du oppga.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Hva annet er det å vurdere?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"><u>Testkampanje</u></span
                ><span lang="en"
                  >: Denne kampanjen vil gjøre det mulig for deg å teste
                  Oral-B-kampanjeproduktene. På denne bakgrunn (og basert på
                  erfaring med sammenlignbare handlinger) må vi definere noen
                  regler i spillet med hensyn til målet for kampanjen:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Deltakelse i kampanjen er bare mulig i ditt eget navn
                        og per person med 5 kjøpsbevis og 5-salgsfremmende
                        produkter.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Hvert kjøpsbevis kan bare brukes én gang for å delta i
                        kampanjen. Dette gjelder også hvis mer enn 5
                        kampanjeprodukter vises på et kjøpsbevis.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Hvis du løser inn en rabattkupong for salgsfremmende
                        produktet samtidig, vil du bare motta refusjon fra
                        Justsnap for beløpet som faktisk er betalt.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Et produkt som allerede har deltatt i en annen
                        kampanje, kan bare refunderes for denne kampanjen frem
                        til den faktiske produktprisen. Dermed, hvis du mottar
                        10EUR /100KR eller 20EUR/200KR i vår Oral-B refusjon
                        kampanje, vil det tilsvarende beløpet bli trukket fra
                        refusjonen din i Pengene Tilbake-kampanjen. Et produkt
                        som refunderes i denne kampanjen, kan ikke brukes i noen
                        annen Procter &amp; Gamble-kampanje.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >I tillegg kombineres hver IBAN og e-postadresse til en
                  brukerkonto og kan bare delta i kampanjen i samme
                  kombinasjon.</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Det pågår ikke noe ansvar for å feilaktig angi
                        IBAN-nummeret. Det er en engangsmulighet til å endre en
                        ugyldig IBAN, hvoretter deltakelsen blir ugyldig. For å
                        endre bankopplysningene dine, kan du kontakte vår
                        supporttjeneste, som utelukkende er satt opp for
                        IBAN-endringer (via e-post:<a
                          style="color: #6eac1c"
                          href="mailto:support@oral-b-moneyback.com"
                        >
                          support@oral-b-moneyback.com </a
                        >) til</span
                      ><a
                        style="color: #6eac1c"
                        href="mailto:support@oral-b-moneyback.com"
                        ><span lang="en"></span></a
                      ><strong> 19.12.2026</strong
                      ><span lang="en">
                        (Hvis du har spørsmål som ikke er relatert til
                        IBAN-endringen, kan du kontakte oss ved hjelp av
                        kontaktalternativene gitt i avsnitt I.)</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ufuldstændige, ukorrekte eller for sent indsendte
                        ansøgninger accepteres ikke. Afsenderbevis vil ikke
                        blive godkendt som bevis for modtagelse. Vi er ikke
                        ansvarlige for formularer og/eller deres indhold, der er
                        forsvundet eller beskadiget eller forsinket.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ved feil innsendt pakkeinnhold har en forbruker en
                        engangsmulighet til å sende de nødvendige dokumentene på
                        nytt. Hvis noe innhold mangler eller er feil ved andre
                        forsøk igjen, blir deltakelsen ugyldig.
                      </span>
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"><u>Forebygging av misbruk og svindel</u></span
                ><span lang="en"
                  >: Etter vår erfaring så langt fører kampanjer som disse
                  dessverre regelmessig til forsøk på misbruk og svindel, noen
                  ganger i betydelig grad. Av denne grunn må vi også ta ulike
                  tiltak for å forhindre og oppdage slike forsøk i denne
                  kampanjen. Vi forstår at dette kan føre til ytterligere arbeid
                  for deg. Vi har imidlertid forsøkt å gjøre våre nødvendige
                  tiltak så ukompliserte som mulig for deg som deltaker:</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Gjennom verifiseringen som er forklart ovenfor i del D
                        som en del av deltakelsesprosessen, sjekker vi om
                        informasjonen fra en deltaker (IBAN og e-postadresse)
                        allerede er brukt til deltakelse i kampanjen; I dette
                        tilfellet kan det hende at hver IBAN i kombinasjon med
                        en e-postadresse oppretter en brukerkonto, denne
                        kombinasjonen kan ikke variere for flere
                        deltakelser.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Under videre behandling vil deltakerinformasjonen også
                        bli sjekket, spesielt strekkodene og kjøpsbeviset lastet
                        opp av deltakerne.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"><u>Oppbevaring av kjøpsbeviset:</u></span
                ><span lang="en"> Vær oppmerksom på at du må beholde </span
                ><span lang="en"
                  ><u
                    >det opprinnelige kjøpsbeviset som brukes til deltakelse til
                    refusjonsbeløpet er mottatt</u
                  ></span
                ><span lang="en"
                  >. I enkelte tilfeller må du sende den i posten for
                  gjennomgang før en refusjon kan utstedes. I dette tilfellet må
                  du sende det opprinnelige kjøpsbeviset i en konvolutt med
                  tilstrekkelig porto til den oppgitte adressen. Ustemplede
                  varer vil ikke bli akseptert, og det originale kjøpsbeviset
                  kan ikke returneres etter at det er kontrollert (vennligst ta
                  en kopi for dine egne formål om nødvendig); intet ansvar for
                  tap per post.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Hva skjer etter din deltakelse? </strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western"><span lang="en">I denne sammenhengen</span></p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Det vil bli gjennomført en sjekk for å forhindre
                        misbruk og svindel. I denne sammenhengen kan du be om
                        det opprinnelige kjøpsbeviset fra deg i
                        enkelttilfeller;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >En e-post vil bli sendt for å bekrefte pengekravet ditt
                        til e-postadressen du oppga; dette gjøres vanligvis
                        innen to virkedager etter fordring av
                        informasjonen;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >P&amp;G Servicesenter bekrefter pakken med deltakende
                        produkt;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Tilbagebetalingsbeløbet vil blive udbetalt til den
                        konto, som du har angivet via IBAN; dette sker normalt
                        inden for seks uger efter eksamen er afsluttet.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Vi forbeholder oss retten til å ekskludere enhver deltaker
                  fra kampanjen hvis det er mistanke om at falsk informasjon ble
                  gitt når vi deltok, det ble gjort forsøk på å manipulere
                  kampanjen eller disse vilkårene og betingelsene ble brutt på
                  annen måte. I dette tilfellet vil ingen bekreftelses-e-post
                  bli sendt til deg. Du kan bevise for oss at det ikke var noe
                  brudd på vilkårene i saken din.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Vi forbeholder oss også retten til å endre eller tilpasse
                  disse vilkårene og betingelsene og til å avbryte, utvide eller
                  avslutte kampanjen når som helst uten forvarsel.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >For deltakere fra Norge gjelder norsk lov, for deltakere fra
                  Sverige gjelder svensk lov, for deltakere fra Finland gjelder
                  finsk lov og for deltakere fra Danmark gjelder dansk lov.
                  Dommernes avgjørelse er endelig.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong
                  >Hvem kan jeg kontakte hvis jeg har spørsmål om
                  kampanjen?</strong
                ></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Hvis du har spørsmål om kampanjen, er den raskeste og eneste
                  måten å kontakte oss på via
                  <strong
                    ><a href="mailto:contact@oral-b-moneyback.com"
                      >contact@oral-b-moneyback.com</a
                    ></strong
                  >
                  . Denne muligheten finnes til </span
                ><span lang="en"><strong>19.12.2026.</strong></span>
              </p>
              <p class="western">
                <span lang="en"
                  >Du kan også kontakte Procter &amp; Gamble International
                  Operations SA via e-post
                  <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com </a
                  >og per post (Route de Saint-Georges 47 1213 PETIT-LANCY,
                  Geneve).</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale == 'se'">
        <h1 class="page-title">Villkor</h1>
        <h2 class="page-title">Oral-B pengarna-tillbaka-garanti</h2>
        <br />
        <div class="text-center mb-5 w-100">
          <div style="font-style: italic">
            Prova vår produkt och få pengarna tillbaka
          </div>
          <br />
          <hr />
          <br />
          <div style="font-style: italic">
            Gillar du inte produkten du köpte? – Inga problem, registrera dig,
            returnera produkten och få pengarna tillbaka!
          </div>
        </div>
        <br />
        <b>Kampanjen i en blick:</b>
        <div class="box-notice">
          <ul>
            <li>
              Köp Oral-B-produkter som deltar under deltagarperioden (mellan
              <b>01.07.2025</b> och <b>31.08.2026</b>) hos en återförsäljare.
            </li>
            <li>
              Registrera dig på reklamwebbplatsen, ladda upp beviset på köpet av
              reklamprodukten och skicka in registreringsformuläret. Efter
              kontroll får du ett e-postmeddelande med uppgifter om återlämnande
              av produkten. När produkten har mottagits tillsammans med alla
              nödvändiga dokument får du pengarna tillbaka för den returnerade
              produkten via banköverföring. Behåll det ursprungliga
              inköpsbeviset!
            </li>
            <li>
              Deltagande i kampanjen är endast möjligt i ditt eget namn och per
              person med
              <b>5 inköpsbevis</b> och <b>5 reklamprodukter</b>
            </li>
            <li>
              Varje inköpsbevis kan endast användas en gång. Om du vill
              returnera mer än en produkt från ett inköpsbevis måste du
              returnera alla produkter på en gång.
            </li>
            <li>
              <b>Viktigt</b>: Du måste registrera ditt kvitto och din produkt
              via vår webbplats
              <a
                href="https://www.oral-b-moneyback.com"
                target="_blank"
                rel="noopener noreferrer"
                >www.oral-b-moneyback.com</a
              >
              inom <b>60 dagar efter köpet</b>. Så snart ditt deltagande online
              har bekräftats har du <b>10 dagar</b> på dig att skriva ut
              returformuläret och skicka det tillsammans med din produkt till
              ett av de P&G Servicecenter som anges i dessa villkor.
            </li>
            <li>
              Tidsfristen för att skicka in den elektroniska
              registreringsblanketten och ladda upp köpekvittot är
              <b>30.10.2026</b>. VVår supportavdelning är tillgänglig till
              <b>19.12.2026</b>.
            </li>
          </ul>
        </div>
        <br />
        <div>
          Tack för ditt intresse för vår Oral-B pengarna-tillbaka-garanti. Även
          om vi försökte ge dig allt väsentligt på en gång: Det är lite mer
          komplicerat. Därför hittar du också det "finstilta" i dessa villkor.
        </div>
        <ul class="list" ref="list">
          <li class="list-item-wrapper">
            <div class="number">Vem deltar i kampanjen?</div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanjen organiseras för deltagare bosatta i Norge, Danmark,
                  Sverige och Finland av Procter &amp; Gamble International
                  Operations SA, Route de Saint-Georges 47, 1213 PETIT-LANCY,
                  Geneve.</span
                >
              </p>
              <p class="western"></p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"><strong>Vad handlar kampanjen om?</strong></span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Kampanjen ger dig möjlighet att prova och returnera vissa
                  Oral-B-produkter inom </span
                ><span lang="en"><strong>60 dagar</strong></span
                ><span lang="en">. Följande produkter ("</span
                ><span lang="en"><strong>reklamprodukter</strong></span
                ><span lang="en">") deltar i denna kampanj:</span>
              </p>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="217" />
                        <col width="87" />
                      </colgroup>
                      <colgroup>
                        <col width="198" />
                        <col width="104" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="217" height="21">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 1</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238331</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307327</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 3</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201291947</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO8 S Violet UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307389</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="20">
                            <p>
                              <span lang="en">Oral-B Laboratory Clean 5</span>
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201238492</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S White UC</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307556</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="217" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="87">
                            <p><span lang="en">4210201309512</span></p>
                          </td>
                          <td width="198">
                            <p><span lang="en">Oral-B iO9 S Black UCB</span></p>
                          </td>
                          <td width="104">
                            <p><span lang="en">4210201307594</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="607" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="220" />
                        <col width="84" />
                      </colgroup>
                      <colgroup>
                        <col width="222" />
                        <col width="81" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality Kids Spiderman CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201320074</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 S Rose Quartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307631</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Mandalorian CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201386230</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 Duo White UC / Black UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201315766</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox +
                                TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201309444</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO6 White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377665</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Star wars CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241201</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Grey Opal UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201377788</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241317</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO6 Pink Sand GC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378143</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Starwars Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241331</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo White UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201378198</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Star Wars</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307105</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2400N Black SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258117</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Kids D12 Starter Pack Frozen</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201307242</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2400N Pink SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258544</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Starter Pack Turquiose CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201260899</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201258643</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Frozen Hbox</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201241379</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2200S Blue SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274681</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 680 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235811</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2900 Black CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271598</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Star Wars Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396109</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2700 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201179078</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 Junior Minnie Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396123</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 White SUT</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201249924</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3400N Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291053</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro2 2500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319412</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3400N Pink Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291077</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro2 2500 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201319313</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3200S Blue Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291091</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2000 Blue CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178682</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro3 3000 PureClean</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201365280</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Oral B Clean &amp; Protect Pro 2 Black
                                CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201396000</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3300W White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291114</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 2 2000 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201267782</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 890 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201235941</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Pro 2 2000 Pink CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201178736</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3900N White Sens +Black Sens</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291503</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO 6N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201409113</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3950N Black CA + Pink CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291374</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO7 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307181</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4900 White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201271611</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Black UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307433</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20400N Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201272922</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO8 SE Violet UC + Pouch</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307464</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20300W White SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201276869</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N Black UCB</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307570</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20200S RoseGold SUT</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201274858</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B iO9 N RoseQuartz UC</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307617</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199441</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Oral-B iO9 N White UC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201307532</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201199472</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO6 Duo Black UC / Pink UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411536</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 170 Blue CA HB</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201201038</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B iO9 Duo Black UC / Rose Quartz UC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201411550</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Junior Green SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202318</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 1</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238355</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Junior Purple SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201202332</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 2</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238454</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 760 Black CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201137191</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GUM CARE 3</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201238515</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 700 Turquoise CA</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201124092</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B PROFESSIONAL GENIUS 10 GUM CARE</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201271864</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 700 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201157786</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality100 Kids Pixar Hbox + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201314592</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 1 750 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201319399</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 150 White CA HB</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201200772</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 750 Pink 3DW</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312499</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Star Wars SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245780</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro1 750 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201312291</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Junior D501 Minnie SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201245896</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro 1 800 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201077596</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255277</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 900 White SUT</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201187370</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274728</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p><span lang="en">Oral-B Pro3 3700 CA</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201291176</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 5000N White CA</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203315</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Pro 3 3000 CA Black Edition</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289364</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5400N White SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201255499</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3000 White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289470</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5200S White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201274773</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Pro3 3500 Black CA Black</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289517</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B GENIUS 8 8100S WHITE SU</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201261414</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="21">
                            <p>
                              <span lang="en">Oral-B Pro3 3500 WT Sensi</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201289562</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Blush Pink SUT</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201279785</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="20">
                            <p>
                              <span lang="en">Oral-B Pro 1 970 White CA</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201207955</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 4 4000N White CA</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201203377</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive White Sensi</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396697</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Oral-B Smart 4 4500 3DW</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201312536</span></p>
                          </td>
                        </tr>
                        <!-- NEW ADDED JSDEV-17782 -->
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro Clean White + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540757802</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Pro1 Duo Black / Turquoise</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090915016</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Pink + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914217</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Black + TC</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8001090914170</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Turquoise + TC</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8001090914132</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Black + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771457</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro1 Turquoise + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540771914</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro1 Pink + Extra Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540771501</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Oral B Clean & Protect Pro 2 Black CA
                              </span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201396024</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head + TC
                              </span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759912</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759929</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540759868</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Black + Extra CA Black Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759790</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 Pink + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540802083</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 Blue + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540759813</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra CA Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760857</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Pro3 White + Extra Sensi Brush Head</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760918</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro3 Duo Black / White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540760765</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro3 Duo Black / Pink</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760277</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Matt Black</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730898</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO3S Ice Blue</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540730935</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO3S Blush Pink</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540730843</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >iO3 Duo Matt Black / Ice Blue</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540731659</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO10 Stardust White</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201435624</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">iO10 Cosmic Black</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201435648</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Laboratory Clean 1</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772119</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Laboratory Clean 3 +1 refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540760345</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">iO Laboratory Clean 5</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201445098</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773178</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772645</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Frozen HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540772409</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + TC</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540773390</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX + Extra
                                Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540773659</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Kids Spiderman HBOX</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540772768</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p><span lang="en">Pro1 Junior 6+ Green</span></p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540743027</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro1 Junior 6+ Purple </span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540742891</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Pro 3 Junior 6+ Star Wars</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">8006540957196</span></p>
                          </td>
                          <td width="222">
                            <p><span lang="en">Pro 3 Junior 6+ Frozen</span></p>
                          </td>
                          <td width="81">
                            <p><span lang="en">8006540774724</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en">Vitality Pro Lilac CA HBOX</span>
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201426967</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en">Vitality Pro Black CA HBOX</span>
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201427063</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA HBOX</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201446392</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Black CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201432326</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="220" height="19">
                            <p>
                              <span lang="en"
                                >Vitality Pro Lilac CA HBOX + Extra Refill</span
                              >
                            </p>
                          </td>
                          <td width="84">
                            <p><span lang="en">4210201432340</span></p>
                          </td>
                          <td width="222">
                            <p>
                              <span lang="en"
                                >Vitality Pro Vapor Blue CA CLS</span
                              >
                            </p>
                          </td>
                          <td width="81">
                            <p><span lang="en">4210201446491</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <dl>
                <dd>
                  <div style="overflow-x: auto">
                    <table width="606" cellspacing="0" cellpadding="0">
                      <colgroup>
                        <col width="227" />
                        <col width="76" />
                      </colgroup>
                      <colgroup>
                        <col width="223" />
                        <col width="80" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td width="227" height="19">
                            <p>
                              <span lang="en"
                                >Oral-B Smart Sensitive WT Sensi + TC</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201396673</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8600 Silver SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201261506</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Smart 5 5900 Black + White CA</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201180074</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8500 Silver CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201314530</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="sv-SE"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8900 Silver CA + Silver 3DW</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201157601</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S Black CA BK</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247357</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20900 RoseG SUT/Black CA
                                Black</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201276982</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X 20100S White SUT</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201247166</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Pink CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200710</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Blush Pink SUT Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295358</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en"
                                >Oral-B Vitality 100 Black CA HB</span
                              >
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201200758</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius X Black CA Black Art of
                                Brushing</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201295402</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="21">
                            <p><span lang="en">Oral-B iO7 S White UC</span></p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201306702</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en">Oral-B Smart 6 6600 Blue CA</span>
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203292</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td width="227" height="20">
                            <p>
                              <span lang="en">Oral-B iO7S Black Onyx UCB</span>
                            </p>
                          </td>
                          <td width="76">
                            <p><span lang="en">4210201364733</span></p>
                          </td>
                          <td width="223">
                            <p>
                              <span lang="en"
                                >Oral-B Genius 8200W White CA</span
                              >
                            </p>
                          </td>
                          <td width="80">
                            <p><span lang="en">4210201203179</span></p>
                          </td>
                        </tr>
                        <template v-for="(item, idx) in newProducts">
                          <tr v-if="idx % 2 === 0" :key="idx">
                            <td width="227" height="20">
                              <p>
                                <span lang="en">{{ item.name }}</span>
                              </p>
                            </td>
                            <td width="76">
                              <p>
                                <span lang="en">{{ item.ean }}</span>
                              </p>
                            </td>
                            <td width="223">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].name
                                    : ""
                                }}</span>
                              </p>
                            </td>
                            <td width="80">
                              <p>
                                <span lang="en">{{
                                  newProducts[idx + 1]
                                    ? newProducts[idx + 1].ean
                                    : ""
                                }}</span>
                              </p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </dd>
              </dl>
              <p class="western"></p>
              <p class="western">
                <span lang="en"><strong>OBS!</strong></span
                ><span lang="en">
                  Du måste registrera ditt kvitto och din produkt via vår
                  webbplats
                  <a href="https://www.oral-b-moneyback.com/se"
                    >www.oral-b-moneyback.com </a
                  >inom <b>60 dagar</b>. Efter bekräftelse av
                  online-registreringen har du </span
                ><span lang="en"><strong>10 dagar </strong></span
                ><span lang="en"
                  >på dig att skicka din produkt tillsammans med den
                  returblankett som bifogats i ditt bekräftelsemail till ett av
                  P&amp;G:s servicecenter som anges nedan.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Återbetalningen motsvarar det faktiskt betalda
                  inköpspriset.</span
                >
                <span lang="en">Kampanjen avser</span>
              </p>
              <ul>
                <li>
                  <p>
                    <span lang="en">köp av reklamprodukter mellan </span
                    ><span lang="en"><strong>01.07.2025 </strong></span
                    ><span lang="en">och </span
                    ><span lang="en"><strong>31.08.2026</strong></span
                    ><span lang="en">("</span
                    ><span lang="en"><strong>kampanjperiod</strong></span
                    ><span lang="en"
                      >"), datumet för inköpsbeviset är relevant;</span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >köp – inklusive onlineköp – från en återförsäljare
                    </span>
                    <span lang="en">("</span
                    ><span lang="en"
                      ><strong>kampanjen återförsäljare</strong></span
                    ><span lang="en">");</span>
                  </p>
                </li>
              </ul>
              <p class="western"></p>
              <ul>
                <li>
                  <p>
                    <span lang="en"
                      >uttryckligen inte på 'privata köp' av kampanjprodukter,
                      inklusive online / auktionsplattformar.</span
                    >
                  </p>
                </li>
              </ul>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"><strong>Vem kan delta i kampanjen?</strong></span>
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en">Du kan delta i kampanjen om du</span>
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >är en slutanvändare som är över 18 år och bosatt i
                        Norge, Danmark, Sverige eller Finland,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ha ett bankkonto med ett IBAN tilldelat ett europeiskt
                        land,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p><span lang="en">ha en e-postadress och</span></p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >har tillgång till kampanjens webbplats på
                        <a href="https://www.oral-b-moneyback.com/se"
                          >www.oral-b-moneyback.com</a
                        >.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Varje IBAN och e-postadress kombineras till ett användarkonto
                  och kan delta i kampanjen endast i en enda kombination.</span
                >
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Hur kan du delta i kampanjen?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en">För att delta i kampanjen måste du</span>
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >ha köpt en deltagande produkt i detaljhandeln under
                        kampanjperioden samt inneha den köpta deltagande
                        produkten och inköpsbeviset,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >öppna onlineformuläret
                        <a href="https://www.oral-b-moneyback.com/se"
                          >www.oral-b-moneyback.com</a
                        >,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ange reklamproduktens streckkod eller ladda upp ett
                        foto av reklamproduktens streckkod,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ladda upp ett foto av ditt inköpsbevis,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ladda upp ett foto av produktsidan med streckkod,</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >ange dina kontouppgifter (IBAN, BIC, kontoinnehavarens
                        för- och efternamn),</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >registrera dig genom att ange din e-postadress och
                        andra personuppgifter och</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >genomföra de steg för verifiering och förebyggande av
                        missbruk/bedrägeri som visas på kampanjens webbplats (se
                        nedan). Genom att klicka på knappen för att slutföra
                        ditt deltagande godkänner du också dessa villkor.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western"></p>
              <p class="western">
                <span lang="en"
                  >genomföra de steg för verifiering och förebyggande av
                  missbruk/bedrägeri som visas på kampanjens webbplats (se
                  nedan). Genom att klicka på knappen för att slutföra ditt
                  deltagande godkänner du också dessa villkor.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Därefter måste du skicka produkten tillsammans med
                  motsvarande kupong till P&amp;G servicecentret inom </span
                ><span lang="en"><strong>inom 10 dagar</strong></span
                ><span lang="en"
                  >. Du får din återbetalning inom 6 veckor efter att paketet
                  anländer och bekräftas i P&G servicecentret.</span
                >
              </p>
              <p class="western">
                <span lang="en"
                  >Deltagandet online måste slutföras inom
                  <b>60 dagar efter köpet</b> Tidsfristen för att skicka in den
                  elektroniska registreringsblanketten och ladda upp köpekvittot
                  är </span
                ><span lang="en"><strong>30.10.2026</strong></span
                ><span lang="en">("</span
                ><span lang="en"><strong>Slutdatum</strong></span
                ><span lang="en">").</span>
              </p>
              <p class="western">
                <span lang="en"
                  >Endast registrerade paket med ett giltigt spårningsnummer kan
                  accepteras. Portokostnaden återbetalas inte.</span
                >
              </p>

              <p class="western">
                <span lang="en"><strong>P&amp;G Servicecentrets </strong></span
                ><span lang="en">adresser i ditt land är:</span>
              </p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Norge</strong></span>
              </h1>
              <p class="western"><span lang="en">L.G. Elektro A/S</span></p>
              <p class="western"><span lang="en">Kolstien 4</span></p>
              <p class="western"><span lang="en">5097 Bergen</span></p>
              <p class="western"><span lang="en">Norge</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Sverige</strong></span>
              </h1>
              <p class="western">
                <span lang="en">El &amp; Digital Service AB</span>
              </p>
              <p class="western"><span lang="en">Folkungagatan 144</span></p>
              <p class="western"><span lang="en">116 30 Stockholm</span></p>
              <p class="western"><span lang="en">Sverige</span></p>
              <p class="western"></p>
              <h1 class="western">
                <span lang="en"><strong>Finland</strong></span>
              </h1>
              <p class="western"><span lang="en">AIDE Europe Oy</span></p>
              <p class="western"><span lang="en">Haukilahdenkatu 4</span></p>
              <p class="western"><span lang="en">FI-00550 Helsinki</span></p>
              <p class="western"><span lang="en">Suomi</span></p>
              <h1 class="western">
                <span lang="en"><strong>Danmark</strong></span>
              </h1>
              <p class="western"><span lang="en">CJ Hvidevareservice</span></p>
              <p class="western"><span lang="en">Thorndahlsvej 11</span></p>
              <p class="western"><span lang="en">9200 Aalborg SV</span></p>
              <p class="western"><span lang="en">Danmark</span></p>
              <p class="western">
                <span lang="en"
                  >Observera följande när det gäller streckkoden på den
                  reklamprodukt som krävs för deltagande och ditt
                  inköpsbevis:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Se till att streckkoden (dvs. den vanliga streckkoden
                        som består av svarta streck med vita mellanslag) syns
                        tydligt på motsvarande produktfoton.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Som inköpsbevis i den mening som avses i dessa villkor
                        gäller endast kvittot eller fakturan från
                        återförsäljaren av kampanjen. Orderbekräftelser,
                        leveranssedlar eller jämförbara dokument är inte
                        tillräckliga.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >På fotot av inköpsbeviset måste uppgifterna om
                        återförsäljaren, kvittots ID (inte bankens
                        transaktions-ID), datum och klockslag för kvittot, den
                        salgsfremmende produkten, priset på den salgsfremmende
                        produkten och kvittots totalbelopp, den angivna momsen
                        och eventuella rabatter som beviljats tydligt
                        framgå.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Fotot av inköpsbeviset får inte vara överexponerat,
                        suddigt eller för mörkt. Skannade kvitton räcker inte
                        för deltagande, utan det krävs detaljerade foton.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >På fotot av inköpsbeviset får endast inköpsbeviset
                        visas; den köpta reklamprodukten får inte fotograferas
                        tillsammans med inköpsbeviset.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >När deltagandet har slutförts med framgång - dvs. när all
                  information som du har lämnat eller laddat upp har mottagits -
                  samt referensnumret för ditt deltagande kommer att visas på
                  kampanjwebbplatsen; du kommer då också att få ett
                  e-postmeddelande till den e-postadress som du har
                  angett.</span
                >
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Vad finns det mer att tänka på?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"><u>Testkampanj</u></span
                ><span lang="en"
                  >: Med denna kampanj vill vi att du ska kunna testa Oral-B
                  reklamprodukterna. Mot denna bakgrund (och baserat på
                  erfarenhet av jämförbara åtgärder) måste vi definiera några
                  spelregler med avseende på kampanjens mål:</span
                >
              </p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Deltagande i kampanjen är endast möjligt i ditt eget
                        namn och per person med 5 inköpsbevis och 5
                        reklamprodukter.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Varje inköpsbevis kan endast användas en gång för att
                        delta i kampanjen; detta gäller även om fler än 5
                        deltagande produkter visas på ett köpbevis.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Om du samtidigt löser in en rabattkupong för
                        reklamprodukten får du endast en återbetalning från
                        Justsnap för det belopp som faktiskt betalats.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >En produkt som redan har deltagit i en annan kampanj
                        kan ersättas för denna kampanj endast upp till det
                        faktiska produktpriset. Om du alltså får 10EUR/100KR
                        eller 20EUR/200KR i vår återbetalning-kampanj för Oral-B
                        kommer motsvarande belopp att dras av från din
                        återbetalning i kampanjen Pengarna tillbaka. En produkt
                        som återbetalas i denna kampanj kan inte användas i
                        någon annan kampanj från Procter &amp; Gamble.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >denna kampanj kan produkten inte användas i en annan Procter
                  &amp; Gamble-kampanj.</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Dessutom kombineras varje IBAN och e-postadress till
                        ett användarkonto och kan endast delta i kampanjen i
                        samma kombination.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Inget ansvar tas på sig om IBAN-numret anges felaktigt.
                        Det finns en engångsmöjlighet att ändra ett ogiltigt
                        IBAN-nummer, varefter deltagandet blir ogiltigt. För att
                        ändra dina bankuppgifter kan du kontakta vår
                        supporttjänst, som är inrättad enbart för IBAN-ändringar
                        (via e-post: </span
                      ><a
                        style="color: #6eac1c"
                        href="mailto:support@oral-b-moneyback.com"
                        ><span lang="en"
                          ><u>support@oral-b-moneyback.com</u></span
                        ></a
                      ><span lang="en">) fram till </span
                      ><span lang="en"><strong>19.12.2026</strong></span
                      ><span lang="en"
                        >. (Om du har några frågor som inte har med
                        IBAN-ändringen att göra, vänligen kontakta oss via de
                        kontaktalternativ som anges i avsnitt I).</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ofullständiga, felaktiga eller sena ansökningar kommer
                        inte att godkännas. Avsändarbevis kommer inte att
                        godkännas som mottagningsbevis. Vi ansvarar inte för
                        blanketter och/eller deras innehåll som har försvunnit
                        eller skadats eller försenats.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Om paketinnehållet har skickats in felaktigt har
                        konsumenten en möjlighet att skicka in de nödvändiga
                        dokumenten på nytt. Om det vid det andra försöket
                        återigen saknas innehåll eller är fel, blir deltagandet
                        ogiltigt.
                      </span>
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  ><u>Förebyggande av missbruk och bedrägeri</u></span
                ><span lang="en"
                  >: Enligt vår erfarenhet hittills leder kampanjer som dessa
                  tyvärr regelbundet till försök till missbruk och bedrägeri,
                  ibland i betydande omfattning. Därför måste vi också vidta
                  olika åtgärder för att förhindra och upptäcka sådana försök i
                  denna kampanj. Vi förstår att detta kan leda till merarbete
                  för er. Vi har dock försökt att göra våra nödvändiga åtgärder
                  så okomplicerade som möjligt för dig som deltagare:</span
                >
              </p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >Genom den kontroll som beskrivs ovan i avsnitt D som en
                        del av deltagandet kontrollerar vi om de uppgifter som
                        deltagaren lämnat (IBAN och e-postadress) redan har
                        använts för deltagande i kampanjen; i detta fall skapar
                        varje IBAN i kombination med en e-postadress ett
                        användarkonto, denna kombination får inte skilja sig åt
                        för flera deltagande.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Under den fortsatta behandlingen kommer
                        deltagarinformationen också att kontrolleras, i
                        synnerhet de streckkoder och inköpsbevis som deltagarna
                        laddat upp.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"><u>Behållning av inköpsbeviset</u></span
                ><span lang="en">: Observera att du måste </span
                ><span lang="en"
                  ><u
                    >behålla det ursprungliga inköpsbeviset som användes för
                    deltagandet tills återbetalningen har mottagits</u
                  ></span
                ><span lang="en"
                  >. I enskilda fall måste du skicka det per post för granskning
                  innan en återbetalning kan utfärdas. I detta fall ska du
                  skicka det ursprungliga inköpsbeviset i ett kuvert med
                  tillräckligt porto till den angivna adressen. Ostämplade varor
                  kommer inte att accepteras och det ursprungliga köpbeviset kan
                  inte returneras efter att det har kontrollerats (vänligen gör
                  en kopia för dina egna ändamål om det behövs); inget ansvar
                  för förluster via post.
                </span>
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong>Vad händer efter ditt deltagande?</strong></span
              >
            </div>
            <div class="list-item-details">
              <p class="western"><span lang="en">I detta sammanhang</span></p>
              <p class="western"></p>
              <ol type="A">
                <ul>
                  <li>
                    <p>
                      <span lang="en"
                        >En kontroll kommer att genomföras för att förhindra
                        missbruk och bedrägeri. I detta sammanhang kan det
                        ursprungliga inköpsbeviset i enskilda fall komma att
                        begäras av dig;</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Ett e-postmeddelande kommer att skickas för att
                        bekräfta ditt krav på pengar till den e-postadress du
                        angett, detta sker vanligtvis inom två arbetsdagar efter
                        det att informationen har mottagits.</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >P&amp;G Service Center bekräftar paketet med deltagande
                        produkt och</span
                      >
                    </p>
                  </li>
                  <li>
                    <p>
                      <span lang="en"
                        >Återbetalningsbeloppet kommer att betalas till det
                        konto som du har identifierat via IBAN; detta görs
                        vanligtvis inom sex veckor efter att provet har
                        avslutats.</span
                      >
                    </p>
                  </li>
                </ul>
              </ol>
              <p class="western">
                <span lang="en"
                  >Vi förbehåller oss rätten att utesluta deltagare från
                  kampanjen om det finns misstankar om att falsk information
                  lämnats vid deltagandet, försök till manipulation av kampanjen
                  eller att dessa villkor på något annat sätt har överträtts. I
                  detta fall kommer inget bekräftelsemail att skickas till dig.
                  Du kan bevisa för oss att det inte förekom något brott mot
                  villkoren i ditt fall.
                </span>
              </p>
              <p class="western">
                <span lang="en"
                  >Vi förbehåller oss också rätten att ändra eller anpassa dessa
                  villkor och att avbryta, förlänga eller avsluta kampanjen när
                  som helst utan föregående meddelande.
                </span>
              </p>
              <p class="western">
                <span lang="en"
                  >För deltagare från Norge gäller norsk lag, för deltagare från
                  Sverige gäller svensk lag, för deltagare från Finland gäller
                  finsk lag och för deltagare från Danmark gäller dansk lag.
                  Domarnas beslut är slutgiltigt.
                </span>
              </p>
              <p class="western"></p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <span lang="en"
                ><strong
                  >Vem kan jag kontakta om jag har några frågor om
                  kampanjen?</strong
                ></span
              >
            </div>
            <div class="list-item-details">
              <p class="western">
                <span lang="en"
                  >Om du har några frågor om kampanjen är det snabbaste och enda
                  sättet att kontakta oss via
                  <a href="mailto:contact@oral-b-moneyback.com"
                    >contact@oral-b-moneyback.com</a
                  >. Denna möjlighet finns fram till</span
                ><span lang="en"><strong> 19.12.2026.</strong></span>
              </p>
              <p class="western">
                <span lang="en"
                  >Du kan också kontakta Procter &amp; Gamble International
                  Operations SA via e-post
                  <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com </a>
                  och per post (Route de Saint-Georges 47 1213 PETIT-LANCY,
                  Geneve).
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "conditions",
  data() {
    return {
      newProducts: [
        {
          name: "Oral-B iO2 Night Black",
          ean: "8700216612272",
        },
        {
          name: "Oral-B iO Laboratory 2 White",
          ean: "8700216615365",
        },
        {
          name: "Oral-B iO2 Forest Green",
          ean: "8700216612364",
        },
        {
          name: "Oral-B iO2 Night Black Limited Edition, Travel Case",
          ean: "8700216610834",
        },
        {
          name: "Oral-B iO2 Calm Pink",
          ean: "8700216612265",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Forest Green",
          ean: "8700216612418",
        },
        {
          name: "Oral-B iO2 Night Black, Travel Case",
          ean: "8700216612159",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Calm Pink",
          ean: "8700216612470",
        },
        {
          name: "Oral-B iO2 Forest Green, Travel Case",
          ean: "8700216612258",
        },
        {
          name: "Oral-B iO3 Matt Black, Travel Case",
          ean: "8006540731536",
        },
        {
          name: "Oral-B iO2 Calm Pink, Travel Case",
          ean: "8700216612210",
        },
        {
          name: "Oral-B iO Laboratory 5 White, Travel Case, 1 extra refill",
          ean: "8700216822121",
        },
        {
          name: "Oral-B iO2 Easy Clean Night Black",
          ean: "8700216627115",
        },
        {
          name: "Oral-B iO Laboratory 6 Black, Travel Case, 1 extra refill",
          ean: "8700216822169",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Calm Pink, 1 Travel Case",
          ean: "8006530016704",
        },
        {
          name: "Oral-B iO2 Kids 6+ Stitch, Travel Case",
          ean: "8700216931564",
        },
        {
          name: "Oral-B iO2 Kids 6+ Stitch",
          ean: "8700216931533",
        },
        {
          name: "Oral-B iO2 Kids 6+ Spiderman",
          ean: "8700216931380",
        },
        {
          name: "Oral-B iO2 Kids 6+ Spiderman, Travel Case",
          ean: "8700216932509",
        },
        {
          name: "Oral-B iO3 Quite White (Whitening Edition), Travel Refill Holder",
          ean: "8006530005241",
        },
        {
          name: "Oral-B iO3 Blush Pink Black, Travel Case",
          ean: "8006530005395",
        },
        {
          name: "Oral-B iO3 Ice Blue, Travel Case",
          ean: "8006530005357",
        },
        {
          name: "Oral-B iO5 Matt Black, Travel Case, Travel Refill Holder",
          ean: "8006530067713",
        },
        {
          name: "Oral-B iO5 Quite White, Travel Case, Travel Refill Holder",
          ean: "8006530068086",
        },
        {
          name: "Oral-B iO5 Blush Pink, Travel Case, Travel Refill Holder",
          ean: "8006530068024",
        },
        {
          name: "Oral-B iO5 Matt Black/Quite White Duo, 1 Travel Case",
          ean: "8006530068130",
        },
        {
          name: "Oral-B iO6 Black Lava, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067850",
        },
        {
          name: "Oral-B iO6 White, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067652",
        },
        {
          name: "Oral-B iO6 Grey Opal, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067805",
        },
        {
          name: "Oral-B iO6 Series Pink Sand Sensitive, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067461",
        },
        {
          name: "Oral-B iO6 Black Lava/Pink Sand Sensitive Duo, 1 Travel Case, 1 Extra Refill",
          ean: "8006530067508",
        },
        {
          name: "Oral-B iO9 Black Onyx, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067591",
        },
        {
          name: "Oral-B iO9 White Alabaster, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067867",
        },
        {
          name: "Oral-B iO9 Rose Quartz, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067935",
        },
        {
          name: "Oral-B iO9 Sapphire Blue, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530093576",
        },
        {
          name: "Oral-B iO9 Duo Black Onyx/Rose Quartz, 1 Charging Travel Case, 1 Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067997",
        },
        {
          name: "Oral-B iO10 Cosmic Black, Charging Travel Case, Travel Refill Holder",
          ean: "8006530067690",
        },
        {
          name: "Oral-B iO10 Stardust White, Charging Travel Case, Travel Refill Holder",
          ean: "8006530067423",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 10px 5px;
}
.page-title {
  width: 100%;
  text-align: center;
  color: var(--brand-color-1);
  font-size: 36px;
  line-height: 40px;
  font-weight: bold;
  margin: 30px;
  @media (max-width: 575px) {
    font-size: 24px;
    line-height: 28px;
  }
}
.box-notice {
  background-color: #dfdfdf;
  border: 1px solid black;
  padding: 15px;
  margin: 5px;
  color: #3d3d41;
}
.list {
  list-style-type: upper-latin;
  word-break: break-word;
  margin: 10px 4px;
  li::marker {
    font-size: 26px;
    font-weight: bold;
    color: var(--brand-color-1);
  }
}
table {
  width: 100% !important;
  td {
    padding: 2px !important;
  }
  @media (max-width: 767px) {
    font-size: 12px;
    td {
      padding: 0 !important;
    }
  }
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
th,
td {
  padding-left: 20px;
  padding-right: 20px;
}
.number {
  color: var(--brand-color-1);
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  display: inline;
  margin-right: 5px;
  p {
    display: inline;
  }
}
p {
  margin-bottom: 5px;
}
.list-item-wrapper {
  margin-top: 24px;
  margin-right: 5px;
  white-space: initial;
  color: var(--brand-color-1);
  .list-item {
    font-weight: normal;
    white-space: initial;
    font-size: 16px;
    line-height: 24px;
  }
  .list-item-details {
    margin-top: 10px;
    text-justify: auto;
    a {
      text-decoration: underline;
    }
  }
}
</style>
